import React from 'react';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { cargarCatalogosGenerico, cargarCatalogosGenericoAsync, cargarCatalogosAsync, cargarCatalogos_Otros, cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import { completar_String } from '../../funciones_globales/format';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import { formatearFecha } from '../../funciones_globales/format';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { formatearLabel, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import PuntoFacturacion from '../ventas/puntoFacturacion';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import GastoImportacionModal from '../componentes_generales/gasto_importacion/GastoImportacionModal';//WILLY 20191216 CAMBIOS EN GASTO IMPORTACION MULTIPLES GASTOS



const BotonLink = styled.button`
    color: #337ab7;
    border: none;
    border-radius: 0;
    font-weight: normal;
    background-color: transparent;
    border-color: transparent;
    &:hover {
        border-color: transparent;        
        text-decoration: underline;
    };
    &:focus {
        border-color: transparent;        
    };
    &:active {
        border-color: transparent;        
    };
    font-size: 11px;
`;

const ContenedorModal = styled.div`  
    margin-top: 20px;
    height: 100%;
    width: 100%;
`;

const ContenedorModalCont = styled.div`  
    margin-top: 20px;
    height: 100%;
    width: 350px;
`;

const ContenedorModalConb = styled.div`  
    margin-top: 20px;
    height: 100%;
    width: 550px;
`;
    
const InputText2 = styled.input`
    height: 27px;
    padding: 5px 10px;
    font-size: 11px;
    line-height: 1.5;
    border-radius: 3px;    
    width: 50%;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
`;

const ContainerEdit = styled.div`    
    border-bottom: 1px solid #cfd8dc;
    height: 50px;  
    padding: 10px;
    margin-bottom: 4px;
`;

const ContenedorBotonAdd = styled.div`
    padding-top: 20px;
    @media (max-width: 991px) {
    padding: 0px;
    }
`;

class FormComp02 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            esGastoImportacion:false,
            estado_formulario: 'G',//WILLY 20191219 -> CAMBIO EN NUMERO DE AUTORIZACIÓN
            importacionesSeleccionadas:[],//WILLY 20191219 -> CAMBIO EN COMPRAS MULTIPLES GASTOS
            esGastoConsolidado:false,//WILLY 20191219 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
            gastos_importacion:[],//WILLY 20191219 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
            numero_consolidado:'',//WILLY 20191219 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
            numero_consolidado_seleccionado:null,
            data_importaciones:[],//WILLY 20191219 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
            total_importacion:0,//WILLY 20191219 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
            total_gasto_general:0,//WILLY 20200106 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
            total_gasto_distribuido:0,//WILLY 20200106 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
            catRubroGastoImportacion_sel:null,
            //Mostrar Tipo Proveedor
            tipo_proveedor:{},
            //Cuenta IVA
            cuenta_IVA: '',
            cuenta_IVA_Des: '',

            //parametro_general
            planVigente:'',
            checkRetencion:0, //1 Checked , 0 Unchecked
            checkContabilidad:0, //1 Checked , 0 Unchecked
            parametroNo_OBJ_IVA: '',
            paramDiasRetencion: null,

            //Importacion
            importacion_sel: null,
            catGastoImportacion_sel: null,
            catGastoImportacion: [],
            ctaParametroImp: null,
            
            //Busqueda
            movCompra: '',

            //Campos
            cod_proveedor: null,
            ConMovimiento: "", //ONLY MODIFICACION 
            num_doc: '',
            num_doc_serie: '',
            num_autorizacion: '',
            anticipo: 0,
            dias_pago: 1,
            concepto: '',

            //Calculo - Compra
            total_doc: 0,
            base_0_doc: 0,
            base_no_obj: 0,
            total_incluye_iva:0,
            calculo_base_iva:0,
            iva_total:0,

            //parametro IVA
            impuesto_IVA: 0,

            //calculo - Retencion
            porcentaje_imp: 0,
            base_IVA_grabado: 0,
            base_ret_renta:0,
            
            valor_IVA: 0,
            val_neto_doc: 0,
            base_imponible: 0,
            valor_impuesto: 0,
            total_retencion: 0,
            rubro: '',

            //control - retencion
            fila_impuesto: '',

            //Calculo - anticipos
            total_anticipos: 0,
            selected_anticipos: 0,
            
            //Centro Costo
            cc_valor:0,
            cc_proncentaje: 0,
            centro_cosot: '',
            
            //adds
            cuenta_add: null,
            valor_add: '',

            //checkbox
            doc_precancelado: false,

            //Modals
            isOpenRetencion: false,
            isOpenContabilidad: false,
            isOpenCentroCosto: false,
            isOpenAnticipoAplicados: false,

            //Selects
            tipoDocumento:[],
            tipoDocumento_sel:null,
            tipoDocDefault: null,
            tipoRetencion:[{value:'B' ,label: 'Bienes'},{value:'S' ,label: 'Servicios'}],
            tipoRetencion_sel:{value:'B' ,label: 'Bienes'},

            opc_impuestos: [],
            opc_impuestos_sel:'',

            opc_tipoCosto: [],
            opc_tipoCosto_sel: '',
            opc_ubicacion: [],
            opc_ubicacion_sel:'',
            
            //colecciones
            tabla_impuestos: [],
            proveedor: '',
            consultCuenta: '',

            //Estados
            //recibo_estado: '',
            operacion: 'G',
            reCrearCont: 'N', //SOLO MODIFICACION -> Indica si se debe Anular la contabilidad ya graba
            errorFechas: 0, //BLOQUEA GUARDA POR RANGOS INCORRECTOS EN LAS FECHAS
            errorCuentas: 0, // El proveedor no tiene asignada una cta Contable o (una cta Anticipo y tiene anticipos por asignar) 
            estadoCompra: 'P',
            manual: null, //Indicado para la fila del GRID RETENCION ha sido cambiado su base manualmente y esta no se actualizara automaticamente
            ult_transaccion: null,//Ultima transaccion operada
            num_diario: null, //Ult. diario
            //Permiso
            permiso:'M', //Permiso por defecto G=> consulta y guarda M => Guarda y Codifica

            //control
            totalDebe: 0,
            totalHaber:0,
            anticiposAplicadosAnulados:[], //Anticipos eliminados para reversar los mismos (SOLO MODIFICACION) 

            //DatePicker
            fecha: null,
            fecha_caducidad: null,
            v: null,
            fecha_proceso: null,

            //ActionButons default disabled
            guardar: true,        
            limpiar: true,
            anular: true,

            //Agregacion
            debitoBancario: 'N',

            //Catalogos
            tipo_compra_opt: [],
            tipo_compra_sel: null,

            
            //GRIDS
            grid_cuentas: [],
            grid_centroCosto: [],
            grid_retenciones: [],
            grid_anticipos:[],
            grid_anticiposAplicados:[], //ONLY MODIFICACION
            grid_contabilidad: [],
             //WILLY 201911216 -> CAMBIOS EN COMPRAS MULTIPLES GASTOS PARA UNA IMPORTACION Y AL CONTRARIO.
            isVisibleModalGastoImportacion:false,
            columnDefs_cuentas: [
                                    {   header: "N° cuenta",
                                        field: "num_cuenta",
                                        width: 90,
                                        type: "string"                                                 
                                    },
                                    {   header: "Descripción",
                                        field: "descripcion_Cuenta",
                                        width: 270,
                                        type: "string"                                                 
                                    },
                                    {   header: "Valor",
                                        field: "valor",
                                        width: 55,
                                        type: "num_decimal" //Willy 2020/01/13 CAMBIOS IMPORTACION MULTIPLE GASTOS                                             
                                    },
                                    {   header: "",
                                        field: "eliminar",
                                        width: 50,
                                        type: "link_elim"                                           
                                    },
                                    {   header: "",
                                        field: "modal",
                                        width: 60,
                                        type: "link_modal"                                           
                                    }                                   
                                ],
            columnDefs_centroCostos:[
                                        {   header: "Tipo costo",
                                            field: "tipo_costo",
                                            width: 120,
                                            type: "string"                                                 
                                        },
                                        {   header: "Ubicación",
                                            field: "ubicacion",
                                            width: 120,
                                            type: "string"                                                 
                                        },
                                        {   header: "Centro costo",
                                            field: "centro_costo",
                                            width: 100,
                                            type: "string"                                                                                   
                                        },
                                        {   header: "%",
                                            field: "porcentaje",
                                            width: 70,
                                            type: "string"                                                                                  
                                        },
                                        {   header: "Valor",
                                            field: "valor",
                                            width: 70,
                                            type: "string"                                                                                  
                                        },
                                        {   header: "Cuenta asociada",
                                            field: "cuenta_asociada",
                                            width: 120,
                                            type: "string"                                                                           
                                        },
                                        {   header: "",
                                            field: "eliminar",
                                            width: 50,
                                            type: "link_elim"                                           
                                        }
                                    ],
            columnDefs_retenciones: [  
                                        {   header: "",
                                            field: "eliminar",
                                            width: 50,
                                            type: "link_elim"                                           
                                        },
                                        {   header: "Tipo",
                                            field: "tipo_descripcion",
                                            width: 50,
                                            type: "string"                                                 
                                        },
                                        {   header: "Cod.",
                                            field: "codigo",
                                            width: 34,
                                            type: "string"                                                 
                                        },
                                        {   header: "Descripción",
                                            field: "descripcion",
                                            width: 120,
                                            type: "string"                                                                                   
                                        },
                                        {   header: "%",
                                            field: "porcentaje",
                                            width: 25,
                                            type: "num_decimal"  //mbaquero 20200427                                                                         
                                        },
                                        {   header: "Base calculo",
                                            field: "base_calculo",
                                            width: 80,
                                            type: "num_decimal"                                           
                                        },
                                        {   header: "Valor",
                                            field: "valor",
                                            width: 50,
                                            type: "num_decimal"                                                                                  
                                        },
                                        {   header: "Rubro",
                                            field: "rubro_num",
                                            width: 50,
                                            type: "string"                                           
                                        },
                                        {   header: "Descripcion rubro",
                                            field: "rubro",
                                            width: 300,
                                            type: "string"                                           
                                        }
                                    ],
            columnDefs_anticipos:[
                                    {   header: "",
                                        width: 30,
                                        suppressRowClickSelection: true,
                                        checkboxSelection: true,
                                        suppressSorting: true,
                                        suppressMenu: true,
                                        suppressFilter: true,
                                        pinned: true                                                
                                    },
                                    {   header: "N°",
                                        field: "ID",
                                        width: 30,
                                        type: "num_entero"                                                 
                                    },
                                    {   header: "Crédito", //"N° Doc."
                                        field: "Movimiento", //Movimiento
                                        width: 70,
                                        type: "string"                                             
                                    },
                                    {   header: "Saldo",
                                        field: "Valor",
                                        width: 60,
                                        type: "num_decimal"                                           
                                    },                                
                                    {   header: "Val. aplica",
                                        field: "Aplica",
                                        width: 80,
                                        type: "num_decimal_edit",
                                        editable: true                                   
                                    },
                                    {   header: "Fec. ingreso",
                                        field: "FECHA",
                                        width: 100,
                                        type: "fecha"                                     
                                    }
                                ],
            cols_contabilidad:[
                                {    header: "N°",
                                    field: "Secuencia",
                                    width: 30,
                                    type: "num_entero"                                                 
                                },
                                {   header: "Cuenta",
                                    field: "Cuenta",
                                    width: 80,
                                    type: "string"                                             
                                },
                                {   header: "Concepto",
                                    field: "Concepto",
                                    width: 255,
                                    type: "string"                                           
                                },                                
                                {   header: "Valor Debe",
                                    field: "ValorD",
                                    width: 80,
                                    type: "num_decimal"                                
                                },
                                {   header: "Valor Haber",
                                    field: "ValorH",
                                    width: 80,
                                    type: "num_decimal"                                     
                                }
                            ],

            columnDefs_anticiposAP:[
                                    {   header: "",
                                        field: "eliminar",
                                        width: 50,
                                        type: "link_elim"                                           
                                    },
                                    {   header: "N°",
                                        field: "ID",
                                        width: 30,
                                        type: "num_entero"                                                 
                                    },                               
                                    {   header: "Val. aplica",
                                        field: "APLICA",
                                        width: 80,
                                        type: "num_decimal"                                 
                                    }
                                    ],
        };
    
      
    //GRID Cuentas
    this.gridOptionsCuentas = {
        context: {
            componentParent: this
        },      
        //singleClickEdit: true,
        enableColResize: true,
        enableCellChangeFlash: true,
        onCellValueChanged: (event)=>{}
    };

    //GRID Centro de costo
    this.gridOptionsCentroCosto = {
        context: {
            componentParent: this
        },      
        //singleClickEdit: true,
        enableColResize: true,
        enableCellChangeFlash: true,
        onCellValueChanged: (event)=>{}
    };

    //GRID Retenciones
    this.gridOptionsRetenciones = {
        context: {
            componentParent: this
        },      
        //singleClickEdit: true,
        enableColResize: true,
        enableCellChangeFlash: true,
        onCellValueChanged: (event)=>{}
    };

    //GRID Contabilidad
    this.gridOptionsContabilidad = {
        context: {
            componentParent: this
        },      
        //singleClickEdit: true,
        enableColResize: true,
        enableCellChangeFlash: true,
        onCellValueChanged: (event)=>{}
    };

    //GRID Anticipos
    this.gridOptionsAnticipos = {
        context: {
            componentParent: this
        },
        rowSelection: "multiple",     
        enableColResize: true,
        enableCellChangeFlash: true,
        onRowSelected: (event)=>{
            this.calcularFilasSeleccionadasANT(event);
            this.crearAsientoContable();
        },
        onCellValueChanged: (event)=>{ 
            if(event.data.Aplica > event.data.Valor){
                alert("El valor a aplicar es mayor al saldo del anticipo");
                event.data.Aplica = event.oldValue;
            }else{
                event.data.Aplica = parseFloat(event.newValue)
            }
            this.apiAT.refreshCells();
            this.calcularFilasSeleccionadasANT(event);
            
            this.crearAsientoContable();
        }
    };
   
    //GRID Anticipos Aplicados
    this.gridOptionsAnticiposAP = {
        context: {
            componentParent: this
        },
        enableColResize: true,
    }

    //Binds
    this.changeMovimientoCompra = this.changeMovimientoCompra.bind(this);
    this.clear = this.clear.bind(this);
    this.changeNumFactura = this.changeNumFactura.bind(this);
    this.changeNumSerie = this.changeNumSerie.bind(this);
    this.validNumSerie = this.validNumSerie.bind(this);
    this.changeValueGeneral = this.changeValueGeneral.bind(this);
    this.changeTotalDoc = this.changeTotalDoc.bind(this);
    this.onGridReadyCu = this.onGridReadyCu.bind(this);
    this.onGridReadyCC = this.onGridReadyCC.bind(this);
    this.onGridReadyAT = this.onGridReadyAT.bind(this);
    this.onGridReadyRET = this.onGridReadyRET.bind(this);
    this.onGridReadyCO = this.onGridReadyCO.bind(this);
    this.changeBaseIVA_0 = this.changeBaseIVA_0.bind(this);
    this.changeBaseNoObjIVA = this.changeBaseNoObjIVA.bind(this);
    this.getOptions_CtaContable = this.getOptions_CtaContable.bind(this);
    this.closeRetencion = this.closeRetencion.bind(this);
    this.generacionRetencionAutomatica = this.generacionRetencionAutomatica.bind(this);
    this.changeProveedor = this.changeProveedor.bind(this);
    this.consolaRET = this.consolaRET.bind(this);
    this.setFechaPago = this.setFechaPago.bind(this);
    this.setProveedor = this.setProveedor.bind(this);    
    this.guardarCompra = this.guardarCompra.bind(this);
    this.changeBase_imponible_RET = this.changeBase_imponible_RET.bind(this);
    this.getCompra = this.getCompra.bind(this);
    this.setOperacion = this.setOperacion.bind(this);
    this.anularCompra = this.anularCompra.bind(this);
    this.validadFacturaProveedor = this.validadFacturaProveedor.bind(this);

    this.validarFechaTrans = this.validarFechaTrans.bind(this);
    this.setIva = this.setIva.bind(this);

    //OVERCONTROLS
    this.changeImportacion = this.changeImportacion.bind(this);

    //OPERATION
    this.cargarImportacion = this.cargarImportacion.bind(this);

    this.impCompra = this.impCompra.bind(this);
    this.impRetencion= this.impRetencion.bind(this);
    //Willy 20191212
    this.limpiaRetencionContabilidad = this.limpiaRetencionContabilidad.bind(this)
    //WILLY 20191216 CAMBIOS EN COMPRAS MULTIPLES GASTO PARA UNA IMPORTACION
    this.abrirModalGasto= this.abrirModalGasto.bind(this)
    this.callbackFunction = this.callbackFunction.bind(this)
    this.actulizaGridGastoCallBack=this.actulizaGridGastoCallBack.bind(this)
    this.actulizaNumeroConsolidadoCallBack= this.actulizaNumeroConsolidadoCallBack.bind(this)
    this.actualizaTotalGeneralCallBack= this.actualizaTotalGeneralCallBack.bind(this)
    this.getConsolidadoImportacion=this.getConsolidadoImportacion.bind(this)
    this.cargarImportacionesCallBack=this.cargarImportacionesCallBack.bind(this)
    this.actualizaTotalesCallBack=this.actualizaTotalesCallBack.bind(this)
    this.actualizaTotalGastoDistribuidoCallBack = this.actualizaTotalGastoDistribuidoCallBack.bind(this)
    this.eliminarImportacionCallback= this.eliminarImportacionCallback.bind(this)
    this.insertarImportacionCallBack= this.insertarImportacionCallBack.bind(this)
    this.limpiarModalImportacionCallBack= this.limpiarModalImportacionCallBack.bind(this)
    this.actualizacatRubroGastoImportacion_selCallBack = this.actualizacatRubroGastoImportacion_selCallBack.bind(this)
    this.closeModal = this.closeModal.bind(this)
    };
    
    
    //Grid API => Cuentas
    onGridReadyCu(params) {
        this.apiCu = params.api;
        this.columnApiCu = params.columnApi;
    }

    //Grid API => CentroCosto
    onGridReadyCC(params) {
        this.apiCC = params.api;
        this.columnApiCC = params.columnApi;
    }

    //Grid API => Anticipo
    onGridReadyAT(params) {
        this.apiAT = params.api;
        this.columnApiAT = params.columnApi;
    }

    //Grid API => RETENCIONES
    onGridReadyRET(params) {
        this.apiRET = params.api;
        this.columnApiRET = params.columnApi;
    }

    onGridReadyAP(params){
        this.apiAP = params.api;
        this.columnApiAP = params.columnApi;
    }

    onGridReadyCO(params){
        this.apiCO = params.api;
        this.columnApiCO = params.columnApi;
    }

    calcularFilasSeleccionadasANT(event){
        var selectedRows = [];
            selectedRows = this.apiAT.getSelectedRows();
            var acc = 0;
            selectedRows.forEach((SL)=>{
                var comprobacion = 0;
                comprobacion = SL.Valor - SL.Aplica
                if(comprobacion === 0){
                    acc = acc + SL.Valor //comprobacion;
                }else{
                    acc = acc + SL.Aplica
                }
            })
            
            //Adicion de saldo ya ingresado (CONSTANTE)
            if(this.state.operacion==='M'){
                if(this.state.grid_anticiposAplicados.length > 0){
                    this.state.grid_anticiposAplicados.forEach((DATA)=>{
                        acc = acc + DATA.APLICA;
                    })
                }
            }

            this.setState({selected_anticipos: Math.round(acc * 100) / 100}, ()=>{
                this.actualizarAnticipo()                
            })
            console.log("GRID ANT: ", this.state.grid_anticipos);
    }
    //WILLY 20191219 -> CAMBIOS EN COMPRAS IMPORTACION MULTIPLES GASTOS E IMPORTACIONES
    limpiarModalImportacionCallBack(tipo){
        
        if(tipo===''){
            this.setState({
                data_importaciones:[],
                numero_consolidado:'',
                catRubroGastoImportacion_sel:null,
                total_importacion:0,
                total_gasto_distribuido:0
            })
        }else{
            this.setState({
                data_importaciones:[],
                numero_consolidado:'',
                total_importacion:0,
                total_gasto_distribuido:0,
                gastos_importacion:[],
                catRubroGastoImportacion_sel:null,
                
            })
        }
       
        
    }
    getConsolidadoImportacion(numero_consolidado){
        if((numero_consolidado!=='' && numero_consolidado!==null)){
            global_axios.get('/importaciones/'+numero_consolidado+'/importacionconsolidada')
                    .then((response)=>{
                       if(response.data.ConsolidadoImportacionResponse!==null&& response.data.ConsolidadoImportacionResponse.length>0){
                        let consolidados= response.data.ConsolidadoImportacionResponse;
                        let data_importaciones=[];
                        let total_importacion=0;
                        for(let j=0; j< consolidados.length;j++)
                        {  //Se calcula el total de la importacion consolidada para obtener el porcentaje.
                            total_importacion=total_importacion+parseFloat(consolidados[j].import.ValorFOB)
                        }
                        let total_todos_decimales=0;
                        let total_dos_decimales=0;
                        for(let i=0; i< consolidados.length;i++)
                        {
                           
                            let porcentaje=(parseFloat(consolidados[i].import.ValorFOB)/parseFloat(total_importacion))*100; 
                          
                            total_todos_decimales=total_todos_decimales+porcentaje;
                            let objeto= {};
                            objeto.Importacion= consolidados[i].Importacion;
                            objeto.ValorFOB = consolidados[i].import.ValorFOB;
                            objeto.Porcentaje = porcentaje.toFixed(2);
                           
                            total_dos_decimales= total_dos_decimales+parseFloat(objeto.Porcentaje)
                            data_importaciones.push(objeto)
                        }
                        let diferenciaDecimales=parseFloat(parseFloat(total_dos_decimales  - total_todos_decimales).toFixed(2));
                        console.log("DIFERENCIA DECIMALES" + diferenciaDecimales)
                        if(diferenciaDecimales>0 || diferenciaDecimales < 0){
                            //Se resta al ultimo gasto la diferencia
                            data_importaciones[data_importaciones.length-1].Porcentaje= parseFloat(parseFloat( data_importaciones[data_importaciones.length-1].Porcentaje) - diferenciaDecimales).toFixed(2);
                        }

                       this.setState({data_importaciones,total_importacion, numero_consolidado_seleccionado:numero_consolidado})  
                       }else{
                           alert('No se encontraron registros para el numero de Consolidado Importación.')
                       }
                    })
                    .catch((err)=>{
                        console.log(err)
                        alert(err.response?err.response.data?err.response.data.msg:err.message:err.message);  
                    });
        }else{
            alert('Ingrese un numero consolidado de importación para continuar...')
        }
    }
    //WILLY 20191219 -> CAMBIOS EN COMPRAS IMPORTACION MULTIPLES GASTOS E IMPORTACIONES
    closeModal =() =>{
        this.setState({isVisibleModalGastoImportacion:false})
    }
    //WILLY 20191219 -> CAMBIOS EN COMPRAS IMPORTACION MULTIPLES GASTOS E IMPORTACIONES
    actualizaTotalGastoDistribuidoCallBack=(childData)=>{
        this.setState({total_gasto_distribuido:childData})
    }
     //WILLY 20191219 -> CAMBIOS EN COMPRAS IMPORTACION MULTIPLES GASTOS E IMPORTACIONES
    actualizacatRubroGastoImportacion_selCallBack=(childData)=>{
        this.setState({catRubroGastoImportacion_sel: childData!==null?childData:null})
    }
    actualizaTotalesCallBack = (childData) => {
        switch(childData.tipo) {
            case 'all':
                this.setState({total_importacion:0})
              break;
            // case y:
            //   // code block
            //   break;
            default:
              // code block
          }
    }  
    actulizaGridGastoCallBack = (childData) => {
        this.setState({gastos_importacion:childData})
    }  
    actulizaNumeroConsolidadoCallBack = (childData) => {
        this.setState({numero_consolidado:childData})  
    } 
    actualizaTotalGeneralCallBack = (childData) => {
        this.setState({total_gasto_general:childData})  
    } 
    cargarImportacionesCallBack= (childData)=>{
        this.getConsolidadoImportacion(this.state.numero_consolidado);
    }
    callbackFunction = (childData) => {
        console.log("CHILDATE")
        console.log(childData)
        let cuentas=[];
        // if(childData.data_gastos.length>1)
        // {
        //     //Es consolidado
        //     this.setState({esGastoConsolidado:true})
        // }else{
        //     this.setState({esGastoConsolidado:false})
        // }
        //Se verifica si existen importaciones gasto ingresadas, en caso de existir se eliminaran
        for(let i = 0; i<this.state.gastos_importacion.length;i++){
            let objeto= {};
            let impo= this.state.gastos_importacion[i];
            objeto.num_cuenta = impo.Cuenta;
            objeto.descripcion_Cuenta= impo.Descripcion.toString().toUpperCase();
            objeto.valor= impo.Valor;
            objeto.centroCosto=0;
            objeto.Importacion= impo.Importacion
            objeto.tipo= 'I'//Importacion
            cuentas.push(objeto)
        }

        this.setState({numero_consolidado:this.state.ConsolidadoImportacionId, grid_cuentas:cuentas, importacionesSeleccionadas:this.state.gastos_importacion, gastos_importacion:this.state.gastos_importacion})

    }  
    changeNumFactura(event){    
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        if(value.length <=9){
            if(isNaN(value)===false){
                this.setState({            
                    [name]: value
                    });
            }
            
        }   
    }

    validadFacturaProveedor(event){
        var errors = "";
        var proceder = true;
        const target = event.target;       
        const value = target.value; 

        if(this.state.cod_proveedor === null || this.state.tipoDocumento===null){
            proceder = false;
            errors=errors+"- Revise los campos proveedor y tipo documento\n"
        }

        if(this.state.num_doc_serie === "" || this.state.num_doc === ""){
            proceder = false;
            errors=errors+"- Ingrese correctamente la serie y la factura"
        }

        if(proceder === true){
            var data = {};
            data.Proveedor = this.state.cod_proveedor.value.toString();
            data.Tipo = this.state.tipoDocumento_sel.value;
            data.Establecimiento = this.state.num_doc_serie.toString().trim().substr(0,3);
            data.PuntoVenta = this.state.num_doc_serie.toString().trim().substr(3,6);
            data.Factura = parseInt(value, 10);
            
            //Validacion factura y serie ingresada 
            let config_request = {
                method: 'GET',
                url: '/compras?proveedor='+data.Proveedor+'&tipo='+data.Tipo+'&establecimiento='+data.Establecimiento+'&puntoventa='+data.PuntoVenta+'&factura='+data.Factura
            };
            
            global_axios(config_request)
            .then((response)=>{
                console.log('VALID RESPUESTA: ', response)
                var array_resultados = [];
                array_resultados = response.data
                if(array_resultados.length>0){
                    if(array_resultados[0].Status!=='A'){
                        alert("La serie y el número de factura ingresado ya existe para este proveedor!");
                        this.setState({num_doc_serie: "", num_doc: ""})
                    }
                }
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }else{
            //Cambia el foco al siguiente control
            //this.input.focus()
            document.getElementsByName('num_autorizacion')[0].focus();
            alert(errors)
        }
    }

    changeNumSerie(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        if(value.length <=6){
            if(isNaN(value)===false){
                this.setState({[name]: value});
            }
        } 
    }

    validNumSerie(event){

        var numSerie = this.state.num_doc_serie.toString();
        var establecimieto = this.state.num_doc_serie.toString().substr(0,3);
        var serie = this.state.num_doc_serie.toString().substr(3,5);

        if(numSerie.length === 6){
            var e = establecimieto
            var s = serie

            if(parseInt(e,10) === 0 || parseInt(s,10) === 0){
                
                this.setState({num_doc_serie: ''});
                document.getElementsByName('num_doc')[0].focus();
                alert("Revisar serie del número de documento");
            }
        }else{
            this.setState({num_doc_serie: ''});
            document.getElementsByName('num_doc')[0].focus();
            alert("Revisar serie del número de documento");
        }
        
    }

    changeValueGeneral(event){    
        const target = event.target;       
        const name = target.name; 
        var value = target.type === 'checkbox' ? target.checked : target.value; 

        if(target.type==='checkbox' && name==='debitoBancario'){
            if(value === true){
                value = 'S';
            }else{
                value = 'N';
            }
        }

        this.setState({            
        [name]: value
        });
    }

    //CUENTAS
    getOptions_CtaContable(input, callback){
        var plan = "";
        if(this.state.planVigente!==null){
            if(this.state.planVigente.length > 0){
                plan = this.state.planVigente
                console.log("PLAN: ", plan)
                if (input.toString().length >= 2 ){
                    let cadena_busq = '?cadena_busq=' + input +'&plan='+plan[0].value.toString();
                    cargarCatalogosGenericoAsync('/cuentas', cadena_busq, callback)
                }
            }
        }
    }

    //RUBRO
    getOptions_RubroImp(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = input;
            cargarCatalogosAsync('Retencion', cadena_busq, callback)
        }
    }

    //TRAE IMPUESTO
    cargarCatalogos_OtrosParametros(tipo) {
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                console.log("COLLECCION DESDE SP: ",response.data)
                
                if(response.data[0].hasOwnProperty('Porcentaje')){
                    this.setState({tabla_impuestos: response.data});
                }
                resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    cargarCatalogos_OtrosParametrosSimplex(tipo) {
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                console.log("COLLECCION DESDE SP: ",response.data)
                
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    cargarCuentasContables(cuenta, plan){
        return new Promise((resolve, reject) => {
            global_axios.get('/cuentas/'+cuenta+'/'+plan)
            .then((response)=>{
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }
    
    changeProveedor(value){
        this.setState({cod_proveedor: value})
        if(value === null || this.state.cod_proveedor !== value){
            if(this.state.grid_retenciones.length > 0){
                this.state.grid_retenciones.forEach((DET, i)=>{
                    this.setState({ grid_retenciones: this.immutableDelete(this.state.grid_retenciones, i) })
                })
            }
            this.setState({proveedor: ''});
            this.setState({total_doc: 0});
            this.setState({base_0_doc: 0});
            this.setState({base_no_obj: 0});
            this.setState({grid_anticipos: []});
            this.setState({grid_retenciones: []});
            this.setState({grid_cuentas: []});
            this.setState({
                importacionesSeleccionadas:[],
                esGastoConsolidado:false,
                gastos_importacion:[],
                numero_consolidado:'',
                numero_consolidado_seleccionado:null,
                data_importaciones:[],
                total_importacion:0,
                total_gasto_general:0,
                total_gasto_distribuido:0
            })
            this.clearRet();
            this.clearTotalizadores();
        }
    }
    
    setProveedor(value){
        if(this.state.cod_proveedor ===null || this.state.cod_proveedor ==='' || Array.isArray(this.state.cod_proveedor)){
            this.setState({proveedor: ''});
            this.setState({num_autorizacion: ''});
            this.setState({fecha_caducidad: null});
            this.setState({grid_anticipos: []});
            this.setState({grid_retenciones: []});
            this.setState({grid_cuentas: []});
            this.clearTotalizadores();
            
        }else{
            
            
            //CALL API
            let config_request = {
                method: 'GET',
                url: '/proveedores/'+this.state.cod_proveedor.value.toString()
            };

            global_axios(config_request)
            .then((response)=>{
                var proveedorData = {};
                proveedorData = response.data

                if(proveedorData.DebitoBancario!==null && this.state.operacion==='G'){
                    this.setState({debitoBancario: proveedorData.DebitoBancario})
                }else if(this.state.operacion==='G'){
                    this.setState({debitoBancario: 'N'})
                }
                console.log(proveedorData.cta_servicio)
                Promise.all([cargarCatalogosGenerico('/catalogos?tipo=tabla&opcion=Retencion&cadena_busq='+response.data.rubro_imp),
                this.cargarCuentasContables(proveedorData.cta_contable!==null?(proveedorData.cta_contable.trim()!== ""?proveedorData.cta_contable.trim():null):null, this.state.planVigente[0].value),
                this.cargarCuentasContables(proveedorData.cta_anticipo!==null?(proveedorData.cta_anticipo.trim()!== ""?proveedorData.cta_anticipo.trim():null):null, this.state.planVigente[0].value),
                this.cargarCuentasContables(proveedorData.cta_servicio!==null?(proveedorData.cta_servicio.trim()!== ""?proveedorData.cta_servicio.trim():null):null, this.state.planVigente[0].value)
                ])
                .then(([respuesta, c_cta_contable, c_cta_anticipo,c_cta_servicio])=>{
                    proveedorData.rubro_imp = respuesta[0];

                    if(proveedorData !== null || proveedorData !== ""){
                        //console.log("AUTORIZACION:",proveedorData.num_autorizacion)
                        if(this.state.estado_formulario!=='M'){//WILLY 20191219 -> CAMBIO EN NUMERO DE AUTORIZACIÓN
                            if(!proveedorData.num_autorizacion){
                                this.setState({num_autorizacion: ""});
                            }else{
                                this.setState({num_autorizacion: proveedorData.num_autorizacion});
                            }
                        }
                        
                        console.log('Proveedor: ', proveedorData)
                        if(proveedorData.fecha_autorizacion){
                            console.log('Proveedor FechaCaducidad: ', proveedorData.fecha_autorizacion)
                            this.setState({fecha_caducidad: moment(proveedorData.fecha_autorizacion, 'DD/MM/YYYY')});
                        }else{
                            this.setState({fecha_caducidad: ''});
                        }
    
                        //OBTENER CUENTA Contable
                        //SE PROCEDE A PREGUNTAR SI EL PROVEEDOR ES DE SERVICIOS O BIENES, EN CASO DE SER DE SERVICIO TOMARA LA CUENTA DE SERVICIOS ASIGNADA EN FICHA PROVEEDOR
                        if(proveedorData.tipo_proveedor==='S'){
                            c_cta_contable=c_cta_servicio;
                        }
                        var cta_contable = {}
                        if(c_cta_contable !== null){
                            cta_contable.value = c_cta_contable.Cuenta;
                            cta_contable.label = c_cta_contable.Nombre;
                            proveedorData.cta_contable = cta_contable
                            this.setState({errorCuentas: 0})
                        }else{
                            proveedorData.cta_contable = null;
                            if(proveedorData.tipo_proveedor==='S'){
                                alert("El proveedor no tiene registrada una cuenta contable de Servicio, no se puede continuar...")
                            }else{
                                alert("El proveedor no tiene registrada una cuenta contable, no se puede continuar...")
                            }
                            this.setState({errorCuentas: 1})
                        }
    
                        //OBTENER CUENTA ANTICIPO
                        var cta_anticipo = {};
                        if(c_cta_anticipo !== null){
                            cta_anticipo.value = c_cta_anticipo.Cuenta;
                            cta_anticipo.label = c_cta_anticipo.Nombre;
                            proveedorData.cta_anticipo = cta_anticipo;
                            
                        }else{
                            proveedorData.cta_anticipo = null;
                        }

                    }else{
                        alert("Error: revise los datos del proveedor seleccionado antes de continuar")
                       
                    }
                    let tipoProveedor={};
                    tipoProveedor.tipo=proveedorData.tipo_proveedor;
                    tipoProveedor.descripcion= proveedorData.tipo_proveedor==='S'?'Servicios':proveedorData.tipo_proveedor==='B'?'Bienes':proveedorData.tipo_proveedor==='I'?'Inventario':''
                    if(this.state.errorCuentas ===1){ //SI EXISTE UN ERROR SE LIMPIARA DE LA PANTALLA LA DESCRIPCIÓN DEL TIPO DEL PROVEEDOR
                        this.setState({tipo_proveedor: {}});
                    }else{
                        this.setState({tipo_proveedor: tipoProveedor});
                    }
                    this.setState({proveedor: proveedorData}, ()=>{
                        //GRID ANTICIPOS
                        let config_request = {
                            method: 'GET',
                            url: '/anticipos?proveedor='+this.state.cod_proveedor.value.toString()
                        };

                        global_axios(config_request)
                        .then((response)=>{
                            var gridTemp = [];
                            gridTemp = response.data;
                            //console.log("GRID ANTICIPO: ",gridTemp)

                            //Validacion de Cuentas del Proveedor ANt.
                            if(proveedorData.cta_anticipo === null && gridTemp.length > 0){
                                alert("El proveedor no tiene registrada una cuenta de anticipos y posee anticipos aplicables, no se puede continuar...")
                                this.setState({errorCuentas: 1})
                            }

                            if(gridTemp.length > 0){
                                this.setState({grid_anticipos: gridTemp}, ()=>{
                                //SELECCIONAR TODAS LAS FILAS AUTOMATICAMENTE
                                if(this.state.operacion === 'G'){
                                    this.apiAT.selectAll();
                                }
                                //Total Anticipo X default
                                this.calculoTotalizarArrayDefault(gridTemp)
                                });
                            }
                        })
                        .catch((error)=>{                
                            alert(error.response?error.response.data.msg:error.message);      
                        });

                    });
                })

            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }
    }

    changeCuentaAdd(value){
        this.setState({cuenta_add: value})
    }

    calculoTotalizarArrayDefault(array){
        var acc = 0;
        array.forEach((ANT)=>{
            var comprobacion = 0;
            comprobacion = ANT.VALOR - ANT.APLICA
            if(comprobacion > 0){
                acc = acc + comprobacion;
            }
        })
        this.setState({total_anticipos: Math.round(acc * 100) / 100 }, ()=>{
            this.actualizarAnticipo()
        })
    }
    
    actualizarAnticipo(){        
        var anticipoTotal = 0;
        anticipoTotal = this.state.selected_anticipos;
        this.setState({anticipo: Math.round(anticipoTotal * 100) / 100})        
    }

    componentDidMount(){
        Promise.all([ 
            this.cargarObjetos('/secuenciales/Compra'),
            this.cargarCatalogos_OtrosParametrosSimplex('COM-PARIMPCTA'), 
            this.cargarCatalogos_OtrosParametrosSimplex('COM-TIPCOMP'), 
            cargarCatalogos_Otros('GEN-PLANVIG') , this.cargarCatalogos_OtrosParametros('COM-IMPALL'),
            cargarCatalogos_Otros('COM-IVAPG'), this.cargarCatalogos_OtrosParametrosSimplex('COM-IVAPG_CTA'), cargarCatalogos_Otros('COM-NOBJIVA'),
            cargarCatalogos_Otros('COM-DIASRET'), cargarCatalogos_Otros('COM-CTTRIBUTAR'), this.props.generar_LogAuditoriaIngresoForm('0602'),
        ])
        .then(([secCompra ,resultParamImpCta ,result_tipoDocumento, r_planVigente, result_IMPUESTO, result_porcentajeIVA, result_Cuenta_IVA, result_paramNOBJIVA, result_DiasRetencion, result_TipoCompra ]) => {
            
            //FORMATEO TIPO COMPRA
            let arrayTipoCompra = [];
            let tipoDocDefault = null;
            result_tipoDocumento.forEach((TIPO)=>{
                let items = {}
                items.value = TIPO.Codigo;
                items.label = TIPO.Descripcion+` (${TIPO.Codigo})`;
                items.NoProcesarRet = TIPO.Observacion;
                items.ImportParam = TIPO.Nombre;

                if(TIPO.Codigo === 'F'){
                    tipoDocDefault = items;
                }
                arrayTipoCompra.push(items)
            })

            //FECHA DE PROCESO POR MODULO
            let fechaProceso = getFechaProcesoPorModulo('06');

            this.setState({ ult_transaccion: completar_String(secCompra.codigo -1, '0', 6) ,ctaParametroImp: resultParamImpCta[0].Descripcion, fecha_proceso: moment(fechaProceso,'DD/MM/YYYY'), 
            fecha: moment(fechaProceso,'DD/MM/YYYY'), tipoDocumento: arrayTipoCompra, planVigente: r_planVigente, 
            opc_impuestos: result_IMPUESTO, impuesto_IVA: parseInt(result_porcentajeIVA[0].value, 10),  cuenta_IVA: result_Cuenta_IVA[0].Cuenta, cuenta_IVA_Des: result_Cuenta_IVA[0].Nombre,
            parametroNo_OBJ_IVA: result_paramNOBJIVA[0], paramDiasRetencion: result_DiasRetencion[0], tipo_compra_opt: result_TipoCompra ,
            permiso: this.props.permiso.toString(), tipoDocDefault: tipoDocDefault, tipoDocumento_sel: tipoDocDefault }, ()=>{
                if(this.state.ctaParametroImp===null){
                    alert("Imposible cargar cuenta parametro de gastos de importación, no se puede continuar")
                }

                //VALIDACION DE PARAMETRO DE DIAS RETENCION (CUANTOS DIAS POR DEBAJO DE LA FECHA DE TRANSACCION PUEDE ESTAR LA FACTURA)
                if(this.state.paramDiasRetencion === null){
                    alert("Parametro de dias retencion no cargado, no puede continuar");
                    this.setState({errorFechas: 1});
                } 

                //SETEO FECHA PARA COMPRA
                this.setFechaPago();
            })
        })
        .catch(()=>{
            alert('Parametros de sistema no han sido cargados.')
        })   
    }

    validacionFechaTransaccion(fecha, fecha_proceso){
        //Comparacion AÑO Y MES
        var fechaFactura = formatearFechaMoment_a_String(fecha).split('/')

        var fechaProceso = fecha_proceso.toString().split('/')
        var ano = fechaProceso[2];
        var mes = fechaProceso[1];
        var dia = fechaProceso[0];
        if(parseInt(this.state.paramDiasRetencion.value,10) === 0){
            if(fechaFactura[2].trim() !== ano.trim() || fechaFactura[1].trim() !== mes.trim()){
                alert("La fecha de factura no corresponde a la fecha de proceso");
                this.setState({errorFechas: 1});
            }else{
                this.setState({errorFechas: 0});
            }
        }else if(parseInt(this.state.paramDiasRetencion.value,10) > 0){
            var fechaFAC = moment(fechaFactura[2]+'-'+fechaFactura[1]+'-'+fechaFactura[0])
            var fechaPRO = moment(ano+'-'+mes+'-'+dia)
            var diasDiff = 0;

            diasDiff = fechaFAC.diff(fechaPRO, 'days')
            diasDiff = (diasDiff * -1)
            if(fechaPRO.diff(fechaFAC, 'days') >= parseInt(this.state.paramDiasRetencion.value,10)){
                alert("La diferencia en dias entre la fecha de factura y la fecha de transaccióm es de "+diasDiff+", excede el limite de dias permitidos ("+this.state.paramDiasRetencion.value+")")
                this.setState({errorFechas: 1});
            }else{
                this.setState({errorFechas: 0});
            }
        }
    }

    changeFecha(fechaFactura){
        this.setState({fecha: fechaFactura},()=>{
            var fechaTrans = formatearFechaMoment_a_String(this.state.fecha_proceso)
            this.validacionFechaTransaccion(this.state.fecha, fechaTrans);

            //CONTRO FECHA VENCIMIENTO
            this.setState({fecha_vencimiento: moment(this.state.fecha, 'DD/MM/YYYY')},()=>{
                this.setState({dias_pago: 1},()=>{
                    this.setFechaPago()
                })
            })
        })
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0602');
    }
    
    //Procedimiento para Ejecutar Funciones AL CAMBIAR EL VALOR DE UN CONTROL HTML
    componentDidUpdate(prevProps, prevState) {

        //CAMBIO UPD VALOR IVA
        if(this.state.valor_IVA !== prevState.valor_IVA && this.state.operacion === "G"){
            console.log("UPDATE! TOTALIZADORES");
            //ACTUALIZA TOTALIZADORES
            this.cargarTotalizadoresRET();
        }
    }

    actualizarValoresGridRetenciones(){
        var acc = 0
        console.log("ENTRO A ACTUALIZAR GRID RETENCION")
        if(this.state.grid_retenciones.length > 0){
            console.log("ACTUALIZANDO FILAS CON DATOS: IVA", this.state.valor_IVA," BASE RENTA: ",this.state.base_ret_renta )
            this.state.grid_retenciones.forEach((RET)=>{
                //Valida si la fila debe actualizarse o no
                if(RET.hasOwnProperty('manual')===false){
                    
                    //Proceso de actualizacion de bases
                    var operacion = 0;
                    if(RET.tipo_imp === "IVA"){
                        RET.base_calculo = Math.round(this.state.valor_IVA * 100) / 100
                        operacion = parseFloat(this.state.valor_IVA, 10) * (RET.porcentaje/100);
                        RET.valor = Math.round(operacion * 100) / 100;
                        acc = acc + RET.valor;
                    }else{
                        RET.base_calculo = Math.round(this.state.base_ret_renta * 100) / 100;
                        operacion = parseFloat(this.state.base_ret_renta, 10) * (RET.porcentaje/100);
                        RET.valor = Math.round(operacion * 100) / 100;
                        acc = acc + RET.valor;
                    }
                }else{
                    //Acumula el valor de retención para mantener actualizado los totalizadores
                    acc = acc + RET.valor;
                }
            })
            
            var opNeto = 0;
            opNeto = parseFloat(this.state.total_doc, 10) - acc;
            this.setState({val_neto_doc: Math.round(opNeto * 100) / 100})
            this.setState({total_retencion: Math.round(acc * 100) / 100});
            
            
        }
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    changeMovimientoCompra(event){
        //Limpia grid y labels
        //this.clear();
        //this.clear_ActionButtons();

        //setea valor nuevo recibo
        const target = event.target;    
        const value = target.value;
        this.setState({movCompra: value},()=>{
            this.clear('B');
            if(value===""){
                this.setState({operacion: "G"})
            }
        });
    }

    setOperacion(){
        var value;
        value = this.state.movCompra

        if(value === ""){
            this.setState({operacion: 'G'});
        }else{
            this.setState({operacion: 'M'});
        }
    }

    getCompra(){
        if(this.state.movCompra === ''){
            alert("Digite un movimiento");
        }else if(parseInt(this.state.movCompra,10) <= 0 ){
            alert("Movimiento no válido");
            this.clear('B');
        }else{
            this.props.cambiar_VisualizacionLoading(true);
            Promise.all([
                this.cargarObjetos('compras/'+this.state.movCompra.toString()),
                this.cargarObjetos('retenciones?compra='+this.state.movCompra.toString()),
                this.cargarObjetos('/anticiposaplicados?compra='+this.state.movCompra.toString()),
                this.cargarObjetos('/compras/'+this.state.movCompra.toString()+'/compraImportacion'),//WILLY 20191219 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
            ])
            .then(([result_compra, result_retencion, result_anticipoAplica,result_compra_importacion])=>{
                console.log("Compra Importacion traida: ", result_compra_importacion)
                console.log("Compra traida: ", result_compra)
                let compra_importacion=result_compra_importacion.objeto.compraImportacion;
                let importaciones = result_compra_importacion.objeto.importaciones;
                let numero_consolidado='';
                let data_importaciones=[];
                let total_gasto_distribuido=0;
                for(let j =0; j<compra_importacion.length; j ++)
                {
                    numero_consolidado= compra_importacion[j].ConsolidadoImportacionId;
                    total_gasto_distribuido=total_gasto_distribuido+compra_importacion[j].Valor;
                }
                if(compra_importacion.length>0){
                    this.setState({esGastoImportacion:true})
                }
                //Se procede a calcular el porcentaje de las importaciones
                let total_importacion=0;
                for(let k=0; k< importaciones.length;k++)
                {  //Se calcula el total de la importacion consolidada para obtener el porcentaje.
                    total_importacion=total_importacion+parseFloat(importaciones[k].ValorFOB)
                }
                let total_todos_decimales=0;
                let total_dos_decimales=0;
                for(let i=0; i< importaciones.length;i++)
                {
                   
                    let porcentaje=(parseFloat(importaciones[i].ValorFOB)/parseFloat(total_importacion))*100; 
                    total_todos_decimales=total_todos_decimales+porcentaje;
                    let objeto= {};
                    objeto.Importacion= importaciones[i].Importacion;
                    objeto.ValorFOB = importaciones[i].ValorFOB;
                    objeto.Porcentaje = porcentaje.toFixed(2);
                    total_dos_decimales= total_dos_decimales+parseFloat(objeto.Porcentaje)
                    data_importaciones.push(objeto)
                }
                let diferenciaDecimales=parseFloat(parseFloat(total_dos_decimales  - total_todos_decimales).toFixed(2));
                console.log("DIFERENCIA DECIMALES" + diferenciaDecimales)
                if(diferenciaDecimales>0 || diferenciaDecimales < 0){
                    //Se resta al ultimo gasto la diferencia
                    data_importaciones[data_importaciones.length-1].Porcentaje= parseFloat(parseFloat( data_importaciones[data_importaciones.length-1].Porcentaje) - diferenciaDecimales).toFixed(2);
                }

                this.setState({numero_consolidado,
                    numero_consolidado_seleccionado:numero_consolidado,
                     estado_formulario:'M',
                     num_autorizacion:result_compra.Autorizacion,
                     gastos_importacion:compra_importacion,
                     data_importaciones,
                    total_importacion,
                    total_gasto_distribuido,
                    importacionesSeleccionadas:compra_importacion})//WILLY 20191219 -> CAMBIO EN NUMERO DE AUTORIZACIÓN
                //Cabecera Compra
                var respuesta = {};
                respuesta = result_compra;

                //Carga de importacion
                if(respuesta.ImportacionGasto!==null){
                    this.cargarImportacion(respuesta)
                }

                //Asignacion Cabecera Compra
                this.setCabCompra(respuesta);

                //Asignacion de Cuentas
                var detalle = [];
                detalle = respuesta.detalle_compra;
                if(detalle.length > 0){
                    this.setCuentasCompra(respuesta);
                }
            
                //Cargar Retenciones
                var retenciones = []; var grid_retencion = []; var accRET = 0;
                retenciones = result_retencion;
                retenciones.forEach((DATA)=>{
                    var item = {};
                    var impuesto = {};

                    if(DATA.Codigo !== null){
                        impuesto = this.catalogoImpuesto_selOne((DATA.Codigo).trim())

                        //DESARROLLO
                        item.CuentaContable = DATA.CuentaRetencion1;
                        item.base_calculo = DATA.BaseCalculo;
                        item.codigo =  (DATA.Codigo).trim();
                        item.descripcion = impuesto.Descripcion;
                        item.generated = 1 //--MODIFICACION
                        item.porcentaje = DATA.Porcentaje
                        item.tipo = DATA.tipoTransaccion
                        item.tipo_descripcion = DATA.tipoTransaccion==='S'?'Servicios':'Bienes';
                        item.rubro_num = (DATA.Drubro!==null?DATA.Drubro.Codigo:"");
                        item.rubro = (DATA.Drubro!==null?DATA.Drubro.Descripcion.toUpperCase():"");
                        item.tipo_imp = (DATA.Observacion==="IVA"?"IVA":"RTF")
                        item.valor = Math.round((DATA.BaseCalculo * (DATA.Porcentaje/100)) * 100) / 100
                        
                        accRET = accRET + item.valor

                        //UPDATE VAL NETO
                        //Actualizacion de valor neto a pagar
                        this.actualizarValorNeto(this.state.val_neto_doc, item.valor, "-");
                        grid_retencion.push(item);
                    } 
                })

                this.setState({grid_retenciones: grid_retencion, total_retencion: Math.round(accRET * 100) / 100})
            
                //Procedimiento anticiposAplicados
                var anticiposAplicados = [];
                anticiposAplicados = result_anticipoAplica;
                if(anticiposAplicados.length > 0){
                    //ANTICIPOS CARGADOS anticiposAplicados
                    this.setState({grid_anticiposAplicados: anticiposAplicados},()=>{
                        this.calcularFilasSeleccionadasANT();
                    }) 
                }

                //Procedimiento Contabilidad                    
                if(this.state.ConMovimiento !== null){
                    this.cargarObjetos('/diarios/'+this.state.ConMovimiento.toString()).then((diarios)=>{
                        console.log("DIARIO: ", diarios)
                        var grid_contable = [];
                        var Debe = 0;
                        var Haber = 0;
                        grid_contable = diarios.detAsiento
                        grid_contable.forEach((DATA)=>{
                            
                            switch (DATA.DebeHaber) {
                                case 'H':
                                    DATA.ValorH = DATA.Valor;
                                    Debe = Debe + DATA.Valor;
                                    break;
                                case 'D':
                                    DATA.ValorD = DATA.Valor
                                    Haber = Haber + DATA.Valor;
                                    break;                            
                                default:
                                    break;
                            }
                        })
                        var item = {};
                        item.Concepto="Total";
                        item.Secuencia=grid_contable.length+1;
                        item.ValorD = Debe
                        item.ValorH = Haber
    
                        grid_contable.push(item);
    
                        this.setState({grid_contabilidad: grid_contable}); 
                    })
                }

                this.setState({operacion: 'M'})
                this.props.cambiar_VisualizacionLoading(false);
            })
            .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);        
                alert(error);      
            });
            
        }
    }

    //Seteo de Cab Compra
    setCabCompra(respuesta){
        var fecha = new Date(respuesta.Fecha).toISOString().substring(0,10)
        this.setState({fecha: moment(formatearFecha(fecha), 'DD/MM/YYYY')})

        cargarCatalogosGenerico('/proveedores?tipo=catalogo&cadena_busq='+respuesta.Proveedor).then((result)=>{
            this.setState({cod_proveedor: result[0]}, ()=>{
                //Asignacion Objeto Proveedor
                this.setProveedor(this.setState.cod_proveedor)

                //Carga DebitoBancario
                if(respuesta.DebitoBancario!==null){
                    console.log("ENTRO A ASIGNAR: ",respuesta.DebitoBancario)
                    this.setState({debitoBancario: respuesta.DebitoBancario})
                }else{
                    this.setState({debitoBancario: 'N'})
                }
            });
        })

        if(respuesta.CreditoTributario){
            this.setState({tipo_compra_sel: respuesta.CreditoTributario})
        }

        //CARGA DEL TIPO DOCUMENTO
        let tipo = null;
        if(respuesta.Tipo){
            this.state.tipoDocumento.forEach((DATA)=>{
                if(DATA.value === respuesta.Tipo){
                    tipo = DATA;
                }
            })
        }
        this.setState({tipoDocumento_sel: tipo})

        var serie = "";
        serie = respuesta.Establecimiento+''+respuesta.PuntoVenta
        this.setState({num_doc_serie: serie, num_doc: respuesta.Factura});

        if(respuesta.Autorizacion!==null){
            this.setState({num_autorizacion: respuesta.Autorizacion})
        }else{
            this.setState({num_autorizacion: ""})
        }
        
        this.setState({ concepto: respuesta.Observacion })
        console.log('FECHA CADUCIDAD: ', respuesta)
        if(respuesta.Caducidad){
            var fechaC = new Date(respuesta.Caducidad).toISOString().substring(0,10)
            this.setState({fecha_caducidad: moment(formatearFecha(fechaC), 'DD/MM/YYYY')})
        }else{
            this.setState({fecha_caducidad: null})
        }        
        
        this.setState({dias_pago: respuesta.DiasPg})

        if(respuesta.PreCancelado !== null){
            this.setState({doc_precancelado: respuesta.PreCancelado})
        }
        
        this.setState({ total_doc: respuesta.Importe, base_0_doc: respuesta.TotalSinIva,
            base_no_obj: respuesta.NoObjIVA, anticipo: respuesta.Anticipo},()=>{
                //Calculo de bases
                this.actualizarTotalIncluyeIVA(this.state.total_doc, this.state.base_0_doc, this.state.base_no_obj);
            })//

            
        var fechaV = new Date(respuesta.FechaVencimiento).toISOString().substring(0,10)
        this.setState({fecha_vencimiento: moment(formatearFecha(fechaV), 'DD/MM/YYYY')})

        if(respuesta.FechaTransaccion!==null){
            var fechaT = new Date(respuesta.FechaTransaccion).toISOString().substring(0,10)
            this.setState({fecha_proceso: moment(formatearFecha(fechaT), 'DD/MM/YYYY')})
        }else{
            this.setState({fecha_proceso: moment()})
        }
        

        //Movimiento cargado
        if(respuesta.ConMovimiento !== undefined){
            this.setState({ConMovimiento: respuesta.ConMovimiento})
        }else{
            this.setState({ConMovimiento: null})
        }
        
        this.setState({estadoCompra: respuesta.Status})
    }

    //Seteo de GRID CUENTAS
    setCuentasCompra(respuesta){
        //centroCosto:0 ,descripcion_Cuenta:"SERVICIO SMS" ,num_cuenta:"52.02.18.07" ,valor:"1500"
        var cuentas = [];
        respuesta.detalle_cuentas.forEach((DATA)=>{
            var item = {};
            item.centroCosto = DATA.IndicadorCC;
            item.descripcion_Cuenta = DATA.Nombre;
            item.num_cuenta = DATA.Cuenta
            item.valor = DATA.Valor;
            if(this.state.ctaParametroImp.trim() === DATA.Cuenta.trim())
            {
                item.tipo='I';
            }
            cuentas.push(item);
        })
        this.setState({grid_cuentas: cuentas})
    }

    //Seteo de Importacion
    cargarImportacion(respuesta){
        let imp = respuesta.ImportacionGasto

        this.cargarObjetos('/importaciones?cadena_busq='+imp.trim()).then((resultImp)=>{
 
            var importacion = {};
            var selected = null;
            importacion.value = resultImp[0].Codigo;
            importacion.label = resultImp[0].Codigo+' ('+resultImp[0].Descripcion+')';

            this.setState({importacion_sel: importacion})

            this.cargarObjetos('/importaciongasto?importacion='+importacion.value).then((resultImp)=>{

                var catalogoReformado = [];
                resultImp.forEach((IMP)=>{
                    var item = {};

                    item.value = IMP.Codigo;
                    item.label = IMP.Descripcion+' ('+IMP.Codigo+')';
                    item.Valor = IMP.Valor;
                    catalogoReformado.push(item);
                })

                catalogoReformado.forEach((CAT)=>{
                    if(respuesta.CodGasto === CAT.value){
                        selected = CAT
                    }
                })

                this.setState({catGastoImportacion: catalogoReformado}, ()=>{
                    this.setState({catGastoImportacion_sel: selected})
                })
                
            })
            .catch((error)=>{
                alert(error.response?error.response.data.msg:error.message);
            })
        })
        .catch((error)=>{
            alert(error.response?error.response.data.msg:error.message);      
        });
    }

    //SELECT IMPUESTO
    catalogoImpuesto_selOne(value){
        var impuesto = {};
        this.state.tabla_impuestos.forEach((IMP)=>{
            if(value !== null){
                if(IMP.Codigo === value){
                    impuesto = IMP;
                }
            }
        })
        return impuesto
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                console.log("ERROR ",err)
                reject('Compra no existe o esta anulada...');
            });
        });
    }

    setCuenta(value){
        if(this.state.cuenta_add === null){
            this.setState({consultCuenta: null})
        }else{
            //CALL API
            var plan = this.state.planVigente
            console.log("PLAN VIGENTE: ", plan[0].value)
            let config_request = {
                method: 'GET',
                url: '/cuentas/'+this.state.cuenta_add.value.toString()+'/'+plan[0].value.toString()
            };

            return new Promise((resolve, reject) => {
                global_axios(config_request)
                .then((response)=>{
                    var cuenta = {};
                    cuenta = response.data
                    console.log("CUENTA TRAIDAS DE CONCUENTA: ",cuenta );
                    this.setState({consultCuenta: cuenta},()=>{
                        resolve(response.data);
                    })
                    
                })
                .catch((error)=>{                
                    alert(error.response?error.response.data.msg:error.message);
                    reject(error);       
                });
            })
        }
    }

    addCuenta(){
        
        if((this.state.cuenta_add !== null) && this.state.valor_add !== '' ){
            Promise.all([this.setCuenta(this.state.cuenta_add.value)])
            .then(([result])=>{

                console.log("CUENTAS CONSULTADAS: ",result)
                var item = {}
                item.num_cuenta = this.state.cuenta_add.value;
                try {
                    item.descripcion_Cuenta = this.state.consultCuenta.Nombre.toString().toUpperCase();
                } catch (error) {
                    item.descripcion_Cuenta = result.Nombre.toString();
                }
                //item.descripcion_Cuenta = this.state.consultCuenta.Nombre.toString().toUpperCase();
                item.valor = this.state.valor_add;
                item.centroCosto = parseInt(this.state.consultCuenta.IndicadorCCosto,10); 

                this.setState(
                    { grid_cuentas: this.immutablePush(this.state.grid_cuentas, item) },()=>{
                        this.setState({cuenta_add: null});
                        this.setState({valor_add: ''});
                        this.setState({consultCuenta: null});
                        this.crearAsientoContable();
                    })
            })
        }else{
            alert("Digitar los campos cuenta y valor para ingresar un nuevo item")
        }
    }

    addCentroCosto(){

    }
    
    //Funcion para estado desplegar
    methodValidateFromParent(datos_fila){
        return (datos_fila.centroCosto===1?0:1);
    }

    //Funcion que recibe parametros de la fila para eliminar
    methodFromParent(id, datos_fila){
       
        var mensaje;
        if(datos_fila.hasOwnProperty('num_cuenta') && datos_fila.hasOwnProperty("descripcion_Cuenta")){
            mensaje = window.confirm("¿Desea eliminar el registro?"); 
           
            if (mensaje){
                if(datos_fila.hasOwnProperty('tipo')){
                    this.abrirModalGasto();
                }else{
                    this.eliminarAsiento(datos_fila ,id) 
                }
              
            }
        }

        if(datos_fila.hasOwnProperty('porcentaje') && datos_fila.hasOwnProperty("base_calculo")){
            mensaje = window.confirm("¿Desea eliminar el registro?"); 
            
            if (mensaje && this.state.operacion === 'G'){
                this.eliminarRetencion(datos_fila ,id) 
            }else{
                alert("No se permite modificar este movimiento")
            }
        }

        if(datos_fila.hasOwnProperty('ID_ANTICIPO') && datos_fila.hasOwnProperty("COMPRA")){
            mensaje = window.confirm("¿Desea eliminar el registro?"); 

            if (mensaje){
                this.eliminarAnticiposAplicados(datos_fila ,id) 
            }
        }

    }

    //funcion que recibe parametros fila e invoca un popup
    methodDeployFromParent(id, datos_fila){
        this.toggleModalCentroC();
    }

    //Nombre para el link de modalpopup
    methodNameFromParent(datos_fila){
        return "CCosto"
    }

    setIva(value){
        this.state.impuesto_IVA=value;
    }


    //Operaciones sobre el cambio de base para el calculo del IVA y bases
    changeTotalDoc(event){

        const target = event.target;       
        const name = target.name; 
        var value = target.type === 'checkbox' ? target.checked : target.value; 

        if(value === ""){
            value = 0;
        }
        
        
       // var  FechaCambioIva = '2024/03/31 00:00:00.000'
       var FechaCambioIva = '2024/03/31'

       
        if ( moment(formatearFechaMoment_a_String(this.state.fecha),'DD/MM/YYYY')<  moment(formatearFechaMoment_a_String(this.FechaCambioIva),'DD/MM/YYYY'))
                {
            this.setIva(12)
            
        }
        else{
            this.setIva(15)
            
        }




        this.setState({total_doc: value}, ()=>{
            if(this.validatePositiveNums(name,value)===true){
                this.actualizarTotalIncluyeIVA(value, this.state.base_0_doc, this.state.base_no_obj);
            }

            if(this.state.grid_retenciones.length > 0){
                this.actualizarValoresGridRetenciones();
            }
        })
    }

    changeBaseIVA_0(event){
        const target = event.target;       
        const name = target.name; 
        var value = target.type === 'checkbox' ? target.checked : target.value;

        if(value === ""){
            value = 0;
        }

        this.setState({base_0_doc: value}, ()=>{
            //Validacion ingreso
            if(this.validatePositiveNums(name,value)===true){
                this.validateTotalDoc(value, name, this.state.base_no_obj);
                this.actualizarTotalIncluyeIVA(this.state.total_doc, value, this.state.base_no_obj);
            }

            if(this.state.grid_retenciones.length > 0){
                this.actualizarValoresGridRetenciones();
            }
        })
    }

    changeBaseNoObjIVA(event){
        const target = event.target;       
        const name = target.name; 
        var value = target.type === 'checkbox' ? target.checked : target.value; 

        if(value === ""){
            value = 0;
        }

        this.setState({base_no_obj: value}, ()=>{
            //Validacion ingreso
            if(this.validatePositiveNums(name,value)===true){
                if(this.validateTotalDoc(value, name, this.state.base_0_doc)===true){
                    this.actualizarTotalIncluyeIVA(this.state.total_doc, this.state.base_0_doc, value);
                }
            }

            if(this.state.grid_retenciones.length > 0){
                this.actualizarValoresGridRetenciones();
            }
        })
    }

    //Validacion de cajas de texto "NUMEROS POSITIVOS"
    validatePositiveNums(name,numero){
        var respuesta = true;
        numero = this.CorrectorCaja(numero)
        if(parseFloat(numero, 10) < 0){
            this.setState({[name]: 0});
            respuesta = false;
            alert("Ingrese solo numeros positivos")
        }
        return respuesta;
    
    }

    validateTotalDoc(value, name, valueExt){
        var result = true;
        var comparacion = 0, total_doc = 0;
        comparacion = parseFloat(value,10)+parseFloat(valueExt,10)
        total_doc = parseFloat(this.state.total_doc, 10);
        if( (Math.round(comparacion * 100) / 100) > (Math.round(total_doc * 100) / 100) ){
            this.setState({[name]: 0});
            result = false;
            alert("El valor ingresado es mayor al total de documento");
        }
        return result;
    }

    CorrectorCaja(value){
        
        var validate
        validate = parseFloat(value)
        if(isNaN(validate)===true){
            return 0
        }else{
            return value
        }
    }

    //FILA AUTOMATICA
    generacionRetencionAutomatica(){
        var arrayTemporal = [];
        var descripcion_imp_IVA = {};
        var descripcion_imp_FTE = {};

        var generated_row_iva = {};
        var generated_row_rte = {};

        var total_imp_grid = 0;
        console.log("ACTIVADO PROCESO GENERACION RETENCION...")
        //Creacion de fila
        //SE PREGUNTA EL TIPO DE PROVEEDOR PARA DE ESTA MANERA CARGAR LAS RETENCIONES PERTENECIENTES A SERVICIO O BIENES
        if(this.state.tipo_proveedor.tipo==='S'){
            if(this.state.proveedor.ret_iva_servicio !== null){
                descripcion_imp_IVA = this.obtenerDataCatalogo(this.state.tabla_impuestos , this.state.proveedor.ret_iva_servicio.toString(), "Codigo");
            }else{
                descripcion_imp_IVA = undefined;
            }
            if(this.state.proveedor.ret_fte_servicio !== null){
                descripcion_imp_FTE = this.obtenerDataCatalogo(this.state.tabla_impuestos , this.state.proveedor.ret_fte_servicio.toString(), "Codigo");
            }else{
                descripcion_imp_FTE = undefined;
            }
        }else{
            if(this.state.proveedor.ret_iva !== null){
                descripcion_imp_IVA = this.obtenerDataCatalogo(this.state.tabla_impuestos , this.state.proveedor.ret_iva.toString(), "Codigo");
            }else{
                descripcion_imp_IVA = undefined;
            }
            if(this.state.proveedor.ret_fte !== null){
                descripcion_imp_FTE = this.obtenerDataCatalogo(this.state.tabla_impuestos , this.state.proveedor.ret_fte.toString(), "Codigo");
            }else{
                descripcion_imp_FTE = undefined;
            }
        }
        
        if(descripcion_imp_IVA !== undefined){
            generated_row_iva = this.generacionFilaIMP(descripcion_imp_IVA);
            arrayTemporal.push(generated_row_iva);
        }

        if(descripcion_imp_FTE !==undefined){
            generated_row_rte = this.generacionFilaIMP(descripcion_imp_FTE);
            arrayTemporal.push(generated_row_rte);
        }
       
        if(descripcion_imp_IVA !== undefined || descripcion_imp_FTE !==undefined){
            console.log("ENTRO A GENERACION DE LINEA VERIFICANDO SI ESTA VACIO.....")
            if(this.state.grid_retenciones.length === 0){
                console.log("GENERANDO LINEAS....")
                this.setState({grid_retenciones: arrayTemporal});
                total_imp_grid = this.updTotalizadoresRetXfilaGenerada(arrayTemporal);
                this.actualizarValorNeto(this.state.val_neto_doc , total_imp_grid ,"-");
                this.setState({total_retencion: Math.round(total_imp_grid * 100) / 100});
            }
        }
    }
    
    generacionFilaIMP(fila){
        
        var item = {};
        var operacion = 0;
        item.codigo = fila.Codigo;
        item.descripcion = fila.Descripcion;
        item.porcentaje =  fila.Porcentaje;

        if(fila.Tipo === "IVA"){
            item.base_calculo = this.state.valor_IVA;
            operacion = parseFloat(this.state.valor_IVA) * parseFloat(fila.Porcentaje/100);
            
        }else{
            item.base_calculo = this.state.base_ret_renta;
            item.rubro = this.state.proveedor.rubro_imp.label;
            item.rubro_num = this.state.proveedor.rubro_imp.value;
            operacion = parseFloat(this.state.base_ret_renta, 10) * (fila.Porcentaje/100);

        }
        if(this.state.proveedor.tipo_proveedor === 'B'){
            item.tipo = 'B';
            item.tipo_descripcion = 'Bienes';
        }else{
            item.tipo = 'S';
            item.tipo_descripcion = 'Servicios';
        }
        
        item.valor = Math.round(operacion * 100) / 100;
        item.tipo_imp = fila.Tipo;
        item.generated = 1;

        //Captura la linea del catalogo de ImpuestoFiscal a trabajar proceder a extraer la cuenta
        let imp = this.serchTablaImp(fila.Codigo)
        item.CuentaContable = this.selectorCuentaImpProveedor(imp);
        return item;
    }

    //Devuelve el total del impuesto automatico genrado
    updTotalizadoresRetXfilaGenerada(array){
        var acc = 0;
        array.forEach((DATA)=>{
            acc = acc + DATA.valor;
        })
        return acc;
    }

    //Devuelve toda la fila del catalogo
    obtenerDataCatalogo(array , valor , name){
        var respuesta;
        this.state.tabla_impuestos.forEach((IMP)=>{
            if(IMP[name] === valor){
                respuesta = IMP;
            }
        })
        return respuesta;
    }

    actualizarTotalIncluyeIVA(total_doc, base_0_doc, base_no_obj){
        var result = 0.00;
        result = parseFloat(total_doc) - parseFloat(base_0_doc) - parseFloat(base_no_obj);
        this.setState({total_incluye_iva: result}, ()=>{

            var valor_IVA, calculo_base_iva = 0.00;
            var impuesto = 0;
            impuesto = 100+parseFloat(this.state.impuesto_IVA)
            calculo_base_iva = this.state.total_incluye_iva/impuesto*100;
            this.setState({calculo_base_iva: Math.round(calculo_base_iva * 100) / 100})
            if(this.state.total_incluye_iva >= 0 ){
                valor_IVA = this.state.total_incluye_iva - calculo_base_iva;
                this.setState({valor_IVA: Math.round(valor_IVA * 100) / 100}, ()=>{
                    
                    //cargar Totalizador RET
                    this.cargarTotalizadoresRET();
                    this.setState({checkRetencion: 0});
                    this.setState({checkContabilidad:0});

                    //Llenar campo con la Total Doc - IVA PAGADO
                    var IVA = parseFloat(this.state.valor_IVA)
                    var total = parseFloat(this.state.total_doc);
                    this.setState({valor_add: Math.round((total-IVA) * 100) / 100, total_gasto_general: Math.round((total-IVA) * 100) / 100})
                })
            }

        });
    }
    
    calculoIVA(base_IVA){
        var valor_IVA, calculo_base_iva = 0.00;
        var impuesto = 0;
        impuesto = 100+parseFloat(this.state.impuesto_IVA)
        // console.log("BASE PARA CALCULO: ",base_IVA)
        // console.log("IMPUESTO + 100: ",impuesto )
        calculo_base_iva = base_IVA/impuesto*100;
        this.setState({calculo_base_iva: Math.round(calculo_base_iva * 100) / 100})
        if(base_IVA >= 0 ){
            // console.log("TOTAL INCLUYE IVA: ", base_IVA )
            // console.log("Calculo Base IVA: ", calculo_base_iva )
            valor_IVA = base_IVA - calculo_base_iva;
            this.setState({valor_IVA: Math.round(valor_IVA * 100) / 100})
        }
    }

    addImpuesto(){

        var errors = "";
        var fila_data = this.state.fila_impuesto;
        //console.log("FILA IMP:", fila_data)
        var continuar = true;

        if(fila_data!==null && this.state.rubro!==null){

            if(this.state.fila_impuesto.Tipo==='RTF'){
                if(this.state.rubro === null || this.state.rubro === ""){
                    errors = errors+"- Seleccione un rubro para continuar.\n";
                    continuar = false;
                }
            }
    
            if(this.state.opc_impuestos_sel === null || this.state.opc_impuestos_sel === ""){
                errors = errors+"- Seleccione un impuesto para continuar.\n";
                continuar = false;
            }
    
            var response = this.validarImpRepetidos(this.state.grid_retenciones, fila_data);
            if(response===true && fila_data.Tipo === "IVA"){
                continuar = false;
                errors = errors+"- Solo puede existir un solo registro de IVA por tipo de retención.\n";
                this.clearRet();
            }else 
            if(response===true && fila_data.Tipo === "RTF"){
                continuar = false;
                errors = errors+"- No puede ingresar un mismo tipo de retencion fuente.\n";
                this.clearRet();
            }
    
            if(this.state.base_imponible === 0){
                continuar = false;
                errors = errors+"- No se puede añadir si no existe base superior a 0.\n";
                this.clearRet();
            }
    
            if(fila_data.Tipo === "RTF"){
                console.log("FILA: ", fila_data )
                if(parseInt(fila_data.Porcentaje,10) !== 0 && this.state.rubro.value === this.state.parametroNo_OBJ_IVA.value){
                    continuar = false;
                    errors = errors+"- La retencion 0 solo se le debe asignar el rubro 332.\n";
                }
            }
    
            var total = this.totalizarGridPorImp(this.state.grid_retenciones, 'valor', 'IVA')
            total = total+parseFloat(this.state.valor_impuesto);

            var iva = parseFloat(this.state.valor_IVA.toFixed(2));

            //Verifica si el total IVA se excede en la pantalla de retencion y el impuesto a Ingresar es IVA
            if(total.toFixed(2)>iva && fila_data.Tipo==='IVA'){
                continuar = false;
                errors = errors+"- El valor ingresado supera a la base del IVA.\n";
            }


            if(continuar === true){
                var item = {};
                var acc = 0.00;
                
                item.codigo = fila_data.Codigo;
                item.descripcion = formatearLabel(this.state.opc_impuestos_sel.label);
                item.porcentaje =  this.state.porcentaje_imp;
                item.base_calculo = this.state.base_imponible;
                item.tipo = this.state.tipoRetencion_sel.value;
                item.tipo_descripcion = this.state.tipoRetencion_sel.label;
                item.valor = this.state.valor_impuesto;
                item.tipo_imp = fila_data.Tipo;
                if(this.state.manual === null){
                    item.inserted = 1;
                }else{
                    //columna indicador de ingreso de base personalizada
                    item.manual = this.state.manual;
                }
                item.CuentaContable = this.selectorCuentaImpProveedor(fila_data); //fila_data.CuentaContable.trim();
    
                if(this.state.fila_impuesto.Tipo==='RTF'){
                    item.rubro = this.state.rubro.label;
                    item.rubro_num = this.state.rubro.value;
                }
                
                var respuesta = this.validarImpRepetidos(this.state.grid_retenciones, fila_data );
                if(respuesta === true){
                    alert("Registro ya ingresado para modificarlo, eliminelo y vuelva a ingresar");
                    this.clearRet();
                }else{
                    
                    //console.log("FILA INSERT: ", item);
                    this.setState(
                        { grid_retenciones: this.immutablePush(this.state.grid_retenciones, item) }
                    )
                    //Total Retencion
                    acc = this.state.total_retencion;
                    acc = acc + item.valor
                    this.setState({total_retencion: Math.round(acc * 100) / 100});
    
                    //Actualizacion de valor neto a pagar
                    this.actualizarValorNeto(this.state.val_neto_doc, item.valor, "-");
    
                    //Limpiar ingreso
                    this.clearRet();
    
                    //Campo para reseteo de base personalizada
                    this.setState({manual: null})
                }
            }else{
                alert(errors)
            }   
        }

        
    }

    totalizarGridPorImp(array, name, tipo_imp){
        let acc = 0;
        array.forEach((DATA)=>{
            console.log("RESULT: ", DATA.tipo_imp === tipo_imp)
            if(DATA.tipo_imp === tipo_imp){
                acc = acc+DATA[name]
            }
        })

        return acc;
    }

    //Suma o resta el valor neto del documento
    actualizarValorNeto(valor_neto , valor ,operacion){
        var val_neto = valor_neto;
        if(operacion === "+"){
            val_neto = val_neto + valor;
        }else{
            val_neto = val_neto - valor;
        }
        this.setState({val_neto_doc: Math.round(val_neto * 100) / 100});
    }

    //ARRAY A EVALUAR - VALOR A BUSCAR - NOMBRE DEL CAMPO
    validarImpRepetidos(array, fila){
        var result = false;

        switch (fila.Tipo) {
            case "RTF":
                array.forEach((DATA)=>{
                    if(DATA.codigo === fila.Codigo){
                        result = true;
                    }
                })
               break;

            case "IVA":
                array.forEach((DATA)=>{
                    if(DATA.tipo_imp === fila.Tipo && DATA.tipo === this.state.tipoRetencion_sel.value){
                        result = true;
                    }
                })
                
               break;
            default:
                break;
        }
        return result;
    }

    eliminarAsiento(datos_fila, id ){
        
        this.setState(
            { grid_cuentas: this.immutableDelete(this.state.grid_cuentas, id) }
        , ()=>{
            this.crearAsientoContable();
        })
        
    }

    eliminarRetencion(datos_fila ,id){

        //Actualizacion de valor neto a pagar
        this.actualizarValorNeto(this.state.val_neto_doc, datos_fila.valor, "+")

        //Actualizacion de valor retencion a pagar
        let valorRetActual = this.state.total_retencion

        this.setState({ grid_retenciones: this.immutableDelete(this.state.grid_retenciones, id), 
        total_retencion: Math.round((valorRetActual-datos_fila.valor)*100)/100 })
    }

    eliminarAnticiposAplicados(datos_fila ,id){
        var eliminados = [];
        eliminados = this.state.anticiposAplicadosAnulados;
        eliminados.push(datos_fila);

        this.setState(
            { grid_anticiposAplicados: this.immutableDelete(this.state.grid_anticiposAplicados, id), anticiposAplicadosAnulados: eliminados }
        ,()=>{
            //Recalculo del total de anticipos CASO MODIFICACION 
            Promise.all([
                this.calcularFilasSeleccionadasANT()
            ])
            .then(() => {
                this.crearAsientoContable();
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });  
        })
    }

    //Procedimiento general de limpiar form
    clear(param){
        this.setState({estado_formulario:'G'})//WILLY 20191219 -> CAMBIO EN NUMERO DE AUTORIZACIÓN
        if(param === 'A'){
            this.setState({movCompra: ''});
        }
        
        //Limpiar grids
        this.setState({grid_anticipos: [], grid_centroCosto: [], grid_contabilidad: [], grid_cuentas: [],
            grid_retenciones: [], anticiposAplicadosAnulados:[]})

        //FECHA DE PROCESO POR MODULO
        let fechaProceso = getFechaProcesoPorModulo('06');
        console.log("ESTOY EN LIMPIAR")
        console.log("FECHA PROCESO")
        console.log(fechaProceso)
    
        //Limpiar datos cabecera
        this.setState({fecha: moment(fechaProceso, 'DD/MM/YYYY') ,cod_proveedor: null,
            tipoDocumento_sel: this.state.tipoDocDefault , num_doc_serie: "", num_doc: "", num_autorizacion: "", 
            fecha_caducidad: null,
            fecha_vencimiento: moment(fechaProceso, 'DD/MM/YYYY').add('days', 1),
            fecha_proceso:  moment(fechaProceso, 'DD/MM/YYYY'),
            doc_precancelado: false , total_doc: 0, base_0_doc:0, base_no_obj: 0, 
            anticipo: 0,dias_pago: 1, cuenta_add: null, valor_add: 0, concepto: "",
            debitoBancario: 'N', tipo_compra_sel: null})
        console.log(this.state.fecha)
        console.log(this.state.fecha_proceso)
        console.log(this.state.fecha_caducidad)
        
    
        //Limpiar Totalizadores
        this.setState({totalDebe: 0, totalHaber: 0, total_anticipos: 0, total_incluye_iva: 0, total_retencion: 0,
            valor_IVA: 0, base_IVA_grabado: 0, base_ret_renta: 0})
    
        //Limpiar calculos internos
        this.setState({selected_anticipos: 0, calculo_base_iva: 0})
    
        //Limpiar Objeto consultado
        this.setState({proveedor: ''});
    
        //Limpiar Controles de importacion
        this.setState({importacion_sel: null,
        catGastoImportacion_sel: null,
        catGastoImportacion: []})
        
        //Limpiar estados
        this.setState({checkRetencion: 0})
        this.setState({operacion: 'G'})
        this.setState({errorFechas: 0});
        this.setState({errorCuentas: 0})
        this.setState({estadoCompra: 'P'})
        this.setState({manual: null})
        //Limpiar Descripcion Tipo
        let tipo_proveedor={};
        tipo_proveedor.tipo='';
        tipo_proveedor.descripcion='';
        this.setState({tipo_proveedor})
        //Limpiar datos modal GastoImportación
        this.setState({
            importacionesSeleccionadas:[],
            esGastoConsolidado:false,
            gastos_importacion:[],
            numero_consolidado:'',
            numero_consolidado_seleccionado:null,
            data_importaciones:[],
            total_importacion:0,
            total_gasto_general:0,
            total_gasto_distribuido:0,
            catRubroGastoImportacion_sel:null
        })
    }

    clearTotalizadores(){
        this.setState({anticipo: 0, valor_IVA: 0, selected_anticipos: 0})
    }

    //CONTROLES DEL INSERT RETENCIONES
    clearRet(){
        this.setState({opc_impuestos_sel: '', porcentaje_imp: 0,
            base_imponible: 0, valor_impuesto: 0, tipoRetencion_sel: {value:'B' ,label: 'Bienes'},
            fila_impuesto: '', rubro: ''});
    }

    //OP Modals
    toggleModalRetencion = () => {
        var arr_Errors = "";
        var proceder = true;
        if(parseFloat(this.state.total_doc) <= 0){
            proceder = false;
            arr_Errors = arr_Errors.concat("- Ingrese el total del documento para acceder a esta opción, \n");  
        }
        
        if(this.state.cod_proveedor === null){
            proceder = false;
            //alert("Seleccione un proveedor antes de continuar...");
            arr_Errors = arr_Errors.concat("- Seleccione un proveedor antes de continuar..., \n");
        }

        if(proceder === false){
            alert(arr_Errors)
        }
        if(proceder===true){
            this.setState({
                isOpenRetencion: !this.state.isOpenRetencion
            }, ()=>{
                //Campo para reseteo de base personalizada
                this.setState({manual: null})

                if(this.state.isOpenRetencion === true){
                    //CHANGE RET
                    if(this.state.operacion === 'G'){
                        this.cargarTotalizadoresRET();
                    }
                    //Comprobacion de operacion
                        if(this.state.operacion === 'G'){
                            if(this.state.grid_retenciones.length === 0){
                                //Generacion automatica de lineas retencion //AUMENTAR CAMPO
                                    this.generacionRetencionAutomatica();
                            }else{
                                this.actualizarValoresGridRetenciones();
                            }
                        }
                    this.setState({checkRetencion: 1});
                }else{
                    this.clearRet();
                }
            });
        }
    }

    //Cierra Modal retencion & Crea Asiento Contable
    closeRetencion(){

        var continuar;
        continuar = this.validarGridRetencion();

        if(continuar === true){
            this.setState({isOpenRetencion:false});
            this.clearRet();
            //GENERAR GRID ASIENTO
            if(this.state.operacion === 'G' || this.state.esGastoImportacion){//wILLY 2020-01-16
                this.crearAsientoContable();
            }
        }else{
            alert("El rubro 332 solo puede ser asignado a 'RETENCION 0' corrija antes de salir")
        }
        
    }

    validarGridRetencion(){
        var cont = true;
        var RET = [];
        RET = this.state.grid_retenciones;
        for(var i = 0; i < RET.length; i++){
            if(RET[i].hasOwnProperty('rubro_num')===true){
                if(RET[i].rubro_num === this.state.parametroNo_OBJ_IVA.value){
                    console.log("COD:", parseInt(RET[i].codigo,10), "COD: ",19)
                    if(parseInt(RET[i].codigo,10) !== 19){
                        cont = false;
                        break;
                    }
                }
            }else{
                continue;
            }
            
        }
        return cont;
    }

    consolaRET(){
        console.log("TIPO RET: ", this.state.tipoRetencion_sel)
        console.log("COMBO IMP: ",this.state.opc_impuestos_sel );
        console.log("Porcentaje: ",this.state.porcentaje_imp );
        console.log("BASE IMPONIBLE: ",this.state.base_imponible );
        console.log("Valor Impuesto: ",this.state.valor_impuesto );
        console.log("FILA CONTROL: ",this.state.fila_impuesto );
    }

    toggleModalContabilidad = () => {
        console.log("HOLAAAAAA")
        console.log(this.state.tipoDocumento_sel)
        if(this.state.tipoDocumento_sel.value==='R'){
            this.crearAsientoContable();
        }
        this.setState({
            isOpenContabilidad: !this.state.isOpenContabilidad
        });        
    }

    toggleModalCentroC = () => {
        this.setState({
            isOpenCentroCosto: !this.state.isOpenCentroCosto
        });
    }

    toggleModalAnticiposAplicados = () =>{
        this.setState({
            isOpenAnticipoAplicados: !this.state.isOpenAnticipoAplicados
        });
    }

    //Op Arrays Inmutables
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    //FUNC CONTABILIDAD
    crearAsientoContable(){
        const proveedor = this.state.proveedor;
        var asiento = [];
        var secuencia= 1;
        console.log("EN EL METODOOOO DE CREAR ASIENTO")
        console.log("grid_cuentas")
        console.log(this.state.grid_cuentas)
        console.log("grid_retenciones")
        console.log( this.state.grid_retenciones)
        console.log("Proveeodr cuenta contable")
        console.log(proveedor.cta_contable)
        //DEBE
        //CUENTAS GASTO 
        this.state.grid_cuentas.forEach((DATA, i)=>{
            // eslint-disable-next-line
            var item = {};
            item.Secuencia = secuencia;
            item.Cuenta = DATA.num_cuenta;
            item.Concepto = DATA.descripcion_Cuenta;
            item.ValorD = parseFloat(DATA.valor);
            item.DebeHaber = 'D';
            if(DATA.tipo==='I'){//WILLY 20191219 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
                item.tipo ='I'
            }
            if(item.ValorD > 0){
                asiento.push(item);
            }
            secuencia=secuencia+1;
        })

        //IVA
        // eslint-disable-next-line
        var item = {};
        item.Secuencia = secuencia;
        item.Cuenta = this.state.cuenta_IVA;
        item.Concepto = this.state.cuenta_IVA_Des.toString().toUpperCase();
        item.ValorD = parseFloat(this.state.valor_IVA);
        item.DebeHaber = 'D';
        secuencia=secuencia+1;

        if(item.ValorD > 0){
            asiento.push(item);
        }
        console.log("IVA")
        console.log(item)
        //HABER
        //CUENTAS x PAG PROVEEDOR
        // eslint-disable-next-line
        var item = {};
        if(proveedor.cta_contable !== null){
            console.log("SELECTED ANTICIPO")
            console.log(this.state.selected_anticipos)
            console.log("VALOR NETO")
            console.log(parseFloat(this.state.val_neto_doc))
            console.log("VALOR CALCULADO")
            console.log(parseFloat(this.state.val_neto_doc)-parseFloat(this.state.selected_anticipos))
            item.ValorH = (parseFloat(this.state.selected_anticipos)===0?parseFloat(this.state.val_neto_doc):parseFloat(this.state.val_neto_doc)-parseFloat(this.state.selected_anticipos));
            if(item.ValorH > 0){
                item.Secuencia = secuencia;
                item.Cuenta = proveedor.cta_contable.value;
                try {
                    item.Concepto = formatearLabel(proveedor.cta_contable.label.toString().toUpperCase());
                } catch (error) {
                    item.Concepto = formatearLabel(proveedor.cta_contable.label);
                }
                item.DebeHaber = 'H';
                asiento.push(item);
                secuencia=secuencia+1;
            }else{
                if(parseFloat(this.state.total_doc, 10) > 0 && parseFloat(this.state.val_neto_doc, 10) > 0){
                    if(parseFloat(this.state.anticipo,10) > parseFloat(this.state.val_neto_doc, 10) ){
                        var resultado = parseFloat(this.state.val_neto_doc, 10)-parseFloat(this.state.anticipo,10);
                        alert("El Anticipo es mayor al valor neto del documentos, exceso de "+Math.round(resultado * 100) / 100)
                    }
                }
            }
        }
        
        //ANTICIPOS AL PROVEEDOR
        
        if(proveedor.cta_anticipo !== null && proveedor.cta_anticipo!== undefined){
            // eslint-disable-next-line
            var item = {};
            item.Secuencia = secuencia;
            item.Cuenta = proveedor.cta_anticipo.value;
            item.Concepto = formatearLabel(proveedor.cta_anticipo.label);
            item.ValorH = parseFloat(this.state.selected_anticipos);
            item.DebeHaber = 'H';
            secuencia=secuencia+1;

            if(item.ValorH > 0){
                asiento.push(item);
            }
            console.log("EN ANTICIPO")
            console.log(item)
        }

        //RETENCIONES
        this.state.grid_retenciones.forEach((RET)=>{
            //var limit = asiento.length+1;
            var imp = {};
            // eslint-disable-next-line
            var item = {}
            imp = this.serchTablaImp(RET.codigo)
            item.Secuencia =secuencia;
            item.Cuenta = this.selectorCuentaImpProveedor(imp);//imp.CuentaContable;
            item.Concepto = imp.Descripcion;
            item.ValorH = parseFloat(RET.valor);
            item.DebeHaber = 'H';

            if(item.ValorH > 0){
                asiento.push(item);
            }
            secuencia=secuencia+1;
        })

        //Totales
        // eslint-disable-next-line
        var item = {};
        item.Secuencia = secuencia;
        item.Concepto = 'Total';
        item.ValorD = this.totalizarAsiento(asiento, 'ValorD');
        item.ValorH = this.totalizarAsiento(asiento, 'ValorH');
        asiento.push(item);
        secuencia=secuencia+1;


        console.log("ASIENTO GENERADO:",asiento );
        this.setState({grid_contabilidad: asiento});
        this.setState({totalDebe: item.ValorD});
        this.setState({totalHaber: item.ValorH});

        if(this.state.operacion === 'M'){
            this.setState({reCrearCont: 'S'});
        }
       
    }

    //Busca en la tabal IMP el impuesto correspondiente
    serchTablaImp(codigo){
        var item = {};
        let tipoPersona = this.state.proveedor.tipo_persona!==null?this.state.proveedor.tipo_persona:null;
        if(parseInt(codigo, 10)!==19){
            if(tipoPersona!==null){
                this.state.tabla_impuestos.forEach((DATA)=>{
                    if(codigo === DATA.Codigo){
                        item = DATA;
                    }
                })
            }else{
                this.setState({errorCuentas: 1})
            }
        }else{
            this.setState({errorCuentas: 0});
        }

        return item
    }

    //SELECCIONA LA CUENTA SEGUN EL TIPO PERSONA DE UN IMP ESPECIFICO
    selectorCuentaImpProveedor(filaImp){
        var tipoPersona = null;
        var result = null;
        tipoPersona = this.state.proveedor.tipo_persona!==null?this.state.proveedor.tipo_persona:null;
        if(tipoPersona!==null){
            if(tipoPersona==='N'){
                if(filaImp.CContableProvPN!==null && filaImp.CContableProvPN!==''){
                    result = filaImp.CContableProvPN
                }
            }else if(tipoPersona==='J'){
                if(filaImp.CContableProvPJ!==null && filaImp.CContableProvPJ!==''){
                    result = filaImp.CContableProvPJ
                }
            }
        }
        if(result===null && filaImp.Codigo!=="19"){
            this.setState({errorCuentas: 1});
            alert('El tipo de retención '+filaImp.Descripcion + "no posee una cuenta contable")
        }
        // else{
        //     this.setState({errorCuentas: 0});
        // }
        
        return result
    }

    totalizarAsiento(array, name){
        var total = 0;
        array.forEach((TOTAL)=>{
            if(isNaN(TOTAL[name])===false){
                total = total + parseFloat(TOTAL[name]);
            }
        })
        
        return total;
    }

    //FUNCIONES MODAL RETENCIONES
    changeImpuesto(value){
        this.setState({opc_impuestos_sel: value})

        if(value === null){
            this.clearRet();
        }else{
            //Select fila del impuesto
            var imp_porcentaje = {};

            this.state.tabla_impuestos.forEach((IMP)=>{
                if(value !== null){
                    if(IMP.Codigo === value.value){
                        imp_porcentaje = IMP;
                    }
                }
            })
            
            //console.log("AH:", imp_porcentaje)
            //filaSeleccionada
            this.setState({fila_impuesto: imp_porcentaje});

            //% PARA CALCULO
            this.setState({porcentaje_imp: imp_porcentaje.Porcentaje});

            
            //BASE IMPONIBLE SEGUN IVA O RTE
            var base_renta;
            if(imp_porcentaje.Tipo === "IVA"){
                var base_incluye_iva 
                base_incluye_iva = this.state.valor_IVA;
                this.setState({base_imponible: Math.round(base_incluye_iva * 100) / 100}); 
            }else if(imp_porcentaje.Tipo === "RTF"){
                base_renta = this.state.base_ret_renta;
                this.setState({base_imponible: Math.round(base_renta * 100) / 100}); 
            }
            

            //VALOR A REGISTRAR
            var result_impuesto;
            
            if(imp_porcentaje.Tipo === "IVA"){
                result_impuesto = parseFloat(this.state.valor_IVA) * (imp_porcentaje.Porcentaje/100);
                this.setState({valor_impuesto: Math.round(result_impuesto * 100) / 100})
            }else{
                result_impuesto = parseFloat(this.state.base_ret_renta) * (imp_porcentaje.Porcentaje/100);
                this.setState({valor_impuesto: Math.round(result_impuesto * 100) / 100})
            }
        }
    }

    changeBase_imponible_RET(event){

        //Validacion base imponible cuando se deje vacio 
        const target = event.target;       
        var value = target.value; 
        //var Temp_base_imponible = parseFloat(this.state.total_doc);
        if(value === "" || parseFloat(value) > parseFloat(this.state.total_doc)){
            value = 0;
        }
        this.setState({base_imponible: value});

        //Calculo de Valor impuesto personalizado
        if(value > 0){
            var valor_impuesto_p = 0;
            //valor_impuesto_p = value * (parseInt(this.state.porcentaje_imp,10)/100); mbaquero 20200427
            valor_impuesto_p = value * (parseFloat(parseFloat(this.state.porcentaje_imp).toFixed(2))/100);
            this.setState({valor_impuesto: Math.round(valor_impuesto_p * 100) / 100}, ()=>{
                //Indicador de marcador
                this.setState({manual: 1});
            })
        }
    }

    cargarTotalizadoresRET(){
        //base_IVA_grabado
        
        var base_incluye_iva;
        base_incluye_iva = this.state.calculo_base_iva;
        this.setState({base_IVA_grabado: Math.round(base_incluye_iva * 100) / 100});

        //Base_ret_RENTA
        var base_renta;
        base_renta = parseFloat(this.state.calculo_base_iva, 10) + parseFloat(this.state.base_0_doc, 10) + parseFloat(this.state.base_no_obj, 10);
        this.setState({base_ret_renta: Math.round(base_renta * 100) / 100 });

        //VALOR NETO DOC. SOLO CAMBIO LA PRIMERA VEZ
        //if(parseFloat(this.state.val_neto_doc, 10) === 0){
            var valor_neto;
            valor_neto = parseFloat(this.state.total_doc);
            this.setState({val_neto_doc: Math.round(valor_neto * 100) / 100}); 
        //}

        console.log("BASE IVA: "+Math.round(base_incluye_iva * 100) / 100+" BASE RENTA:" +Math.round(base_renta * 100) / 100+" VALOR NETO: "+Math.round(valor_neto * 100) / 100)
    }

    SumarFecha(fecha, dias){
        var fechaparts = fecha.split("/");
        var fch_sist_ = new Date(parseInt(fechaparts[2],10), parseInt(fechaparts[1],10)-1, parseInt(fechaparts[0],10))
        // eslint-disable-next-line
        var fecha = fch_sist_;

        var dayOfMonth = fecha.getDate();
        fecha.setDate(dayOfMonth + dias);
        return fecha;
    }

    setFechaPago(){
        var fechaNew;
        if(parseInt(this.state.dias_pago,10) > 0){
            fechaNew = this.SumarFecha((moment(this.state.fecha).format('L')).toString(), parseInt(this.state.dias_pago, 10));
            this.setState({fecha_vencimiento: moment(fechaNew, 'DD/MM/YYYY')});
        }else if(parseInt(this.state.dias_pago,10) < 0 || this.state.dias_pago === ""){            
            this.setState({dias_pago: 0}, ()=>{
                this.setState({fecha_vencimiento: moment(this.state.fecha, 'DD/MM/YYYY')})
            })
        }  
    }

    generarGrid_BASES(){

        var result = [];
        var count = 0
        //No OBJ IVA
        if(parseFloat(this.state.base_no_obj)>0){
            var item = {};
            
            count = count + 1
            item.Localidad = '01';
            item.Compra = '';
            item.Secuencia = completar_String(count, '0', 3);
            item.Articulo = 'SER001';
            item.Precio = parseFloat(this.state.base_no_obj);
            item.Variedad = 1

            result.push(item);
        }
        
        //BASE IVA
        if(parseFloat(this.state.base_IVA_grabado)>0){

            // eslint-disable-next-line
            var item = {};
            count = count + 1
            item.Localidad = '01';
            item.Compra = '';
            item.Secuencia = completar_String(count, '0', 3);
            item.Articulo = 'SER001';
            item.Precio = parseFloat(this.state.base_IVA_grabado);
            item.Iva = 1

            result.push(item);
        }
        
        //BASE IVA 0%
        if(parseFloat(this.state.base_0_doc)>0){
            // eslint-disable-next-line
            var item = {};
            count = count + 1
            item.Localidad = '01';
            item.Compra = '';
            item.Secuencia = completar_String(count, '0', 3);
            item.Articulo = 'SER001';
            item.Precio = parseFloat(this.state.base_0_doc);

            result.push(item);
        }
        
        return result
    }

    validacionDataImpCompleta(){
        let complete = true;
        if(this.state.importacionesSeleccionadas.length===0){
            complete = false;
        }else{
            let found = false;
            this.state.grid_cuentas.forEach((CTAS)=>{
                if(CTAS.num_cuenta.toString().trim() === this.state.ctaParametroImp.toString().trim()){
                    found = true;
                }
            })
            if(found === false){
                complete = false;
            }
        }

        return complete
    }

    guardarCompra(){
        var errors = "";
        var proceder = true;
        var seleccionados = [];
        var valorImportacion = 0;
        var mensajeRET0 = '';

        let fechaProcesoModulo = getFechaProcesoPorModulo('06');
    
        //VALIDACION DE FECHA DE CIERRE CONTABLE        
        var fechaCierreCont = moment(getItemDatosSesion('fechaUltCierreCont'), 'DD/MM/YYYY');
        var fechaProceso = this.state.fecha_proceso;
        var fechaFactura = this.state.fecha;
    
        //VERIFICACION DE FECHA CIERRE CONTABLE
        if(fechaProceso.diff(fechaCierreCont,'days')<=0){
            proceder = false;
            errors = errors+'- La fecha de transacción no puede ser menor a la fecha de contable\n';
        }
    
        //VERIFICACION FECHA TRANSACCION CON FECHA FACTURA
        if(fechaFactura.isAfter(fechaProceso)===true){
            proceder = false;
            errors += '- La fecha factura no puede ser mayor a la fecha de transacción\n'
        }
        
        // Validacion de fecha de proceso que se puede cambiar ------------------------------
        if(this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fecha_proceso, moment(fechaProcesoModulo, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
            }
        }
    
        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }
    
        //Validacion si existe una importacion seleccionada
        if(this.state.importacionesSeleccionadas.length>0){//Willy 20191223 -> CAMBIOS EN COMPRAS MULTIPLES IMPORTACIONES Y GASTOS
                var found = false;
                this.state.grid_cuentas.forEach((CTAS)=>{
                    console.log("REVISION DE CUENTA: ", CTAS.num_cuenta.toString().trim(), this.state.ctaParametroImp.toString().trim(), CTAS.num_cuenta.toString().trim() === this.state.ctaParametroImp.toString().trim())
                    if(CTAS.num_cuenta.toString().trim() === this.state.ctaParametroImp.toString().trim()){
                        found = true;
                        valorImportacion = parseFloat(CTAS.valor).toFixed(2)
                    }
                })
                if(found === false){
                    proceder = false;
                    errors = errors+'- Ingrese la cuenta del gasto de importación antes de proceder.\n'
                }
        }else{
            //Verifica Cuenta de provision ingresada sin importacion
            this.state.grid_cuentas.forEach((CTAS)=>{
                console.log("REVISION DE CUENTA: ", CTAS.num_cuenta.toString().trim(), this.state.ctaParametroImp.toString().trim(), CTAS.num_cuenta.toString().trim() === this.state.ctaParametroImp.toString().trim())
                if(CTAS.num_cuenta.toString().trim() === this.state.ctaParametroImp.toString().trim()){
                    proceder = false;
                    errors = errors+'- Seleccione una importacion y un gasto antes de continuar.\n'
                }
            })
        }
    
        if(this.state.num_doc_serie === "" || this.state.num_doc === ""){
            proceder = false;
            errors = errors +"- Revisar N° de documento. \n";
        }
    
        if(this.state.concepto === ""){
            proceder = false;
            errors = errors +"- Ingrese un concepto antes de guardar.\n";
        }
    
        //Proceso validar anticipos --CHECK
        seleccionados = this.apiAT.getSelectedRows();
        if(seleccionados.length > 0){
            var total_anticipo = this.validarTotalArray(seleccionados , 'Aplica' )
            if(total_anticipo > parseFloat(this.state.total_doc,10)){
                proceder = false;
                errors = errors +"- Los anticipos son mayores al total documento....\n";
            }
        }else{
            if(this.state.grid_anticipos.length > 0){
                alert("- Sin anticipos a incluir en la compra")
            }
        }
        
        //Proceso validar retenciones
        if(parseFloat(this.state.total_retencion, 10) > parseFloat(this.state.val_neto_doc, 10) ){
            proceder = false;
            errors = errors +"- Las retenciones ingresadas ("+this.state.calculo_base_iva+") superan al valor neto calculado ("+this.state.val_neto_doc+")\n";
        }
    
        //Proceso validar Asiento
        if(this.state.grid_cuentas.length === 0){
            proceder = false;
            errors = errors +"- Ingrese al menos una cuenta \n";
        }
       
        if( Math.round(parseFloat(this.state.totalDebe)* 100)/ 100 !== Math.round(parseFloat(this.state.totalHaber)* 100)/ 100){
            proceder = false;
            errors = errors +"- El total debe "+this.state.totalDebe+" no es igual al total haber "+this.state.totalHaber+"\n";
        }
    
        //Validar que exista tipo compra
        if(!this.state.tipo_compra_sel){
            proceder = false;
            errors = errors +"- Seleccione un tipo de compra \n";
        }

        if(!this.state.tipoDocumento_sel){
            proceder = false;
            errors = errors +"- Seleccione un tipo de documento \n";
        }else if(this.state.tipoDocumento_sel.ImportParam !== null){
            let completa = this.validacionDataImpCompleta();
            console.log('VALIDACION DATA COMPLETA: ', completa);
            if(completa === false){
                proceder = false;
                errors = errors +"- Para recibos seleccione una importacion e ingrese su respectiva cuenta.\n";
            }
        }else{
            //Proceso validar Asiento
            if(this.state.grid_retenciones.length === 0 && this.state.tipoDocumento_sel.NoProcesarRet=== null){
                proceder = false;
                errors = errors +"- Ingrese al menos una retencion \n";
            }

            if(this.state.checkRetencion === 0 && this.state.tipoDocumento_sel.NoProcesarRet === null){
                proceder = false;
                errors = errors +"- Revisar retenciones antes de guardar....\n";
            }
        }
    
        if(proceder === true){
            //Procedimiento guardar
            var data = {};
    
            //Cabecera Compra
            data.Proveedor = this.state.cod_proveedor.value;
            data.NomProveedor = formatearLabel(this.state.cod_proveedor.label)
            data.Factura = this.state.num_doc.toString().trim();
            
            //TIPO DE DOCUMENTO ENVIADO;
            data.Tipo = this.state.tipoDocumento_sel.value;

            //PARAMETRO PARA PROCESAR RETENCION (PROCESA RET === NULL)
            data.NoProcesarRet = this.state.tipoDocumento_sel.NoProcesarRet;

            data.Fecha = formatearFechaMoment_a_String(this.state.fecha); //FECHA FACTURA
            data.FechaVencimiento = formatearFechaMoment_a_String(this.state.fecha_vencimiento);
            data.FechaTransaccion = formatearFechaMoment_a_String(this.state.fecha_proceso); //FECHA TRANSACCION
    
            data.DiasPg = parseInt(this.state.dias_pago,10);
            data.concepto = this.state.concepto.toString().toUpperCase();
            data.FormaPago = 'CR';
    
            data.Importe = parseFloat(this.state.total_doc, 10)
            data.TotalConIVA = parseFloat(this.state.base_IVA_grabado, 10);
            data.TotalSinIVA = parseFloat(this.state.base_0_doc, 10);
            data.NoObjIVA = parseFloat(this.state.base_no_obj, 10);
            data.IVA = parseFloat(this.state.valor_IVA, 10);
    
            data.PreCancelado = this.state.doc_precancelado
    
            data.Moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
            data.Dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;
            data.Usuario = getItemDatosSesion('usuario');
            data.Autorizacion = this.state.num_autorizacion;
            data.Establecimiento = this.state.num_doc_serie.toString().substr(0,3)
            data.PuntoVenta = this.state.num_doc_serie.toString().substr(3,6)
            data.Status = 'P';//CHECK SEGUN PRECANCELADO => C?
            data.CreditoTributario = this.state.tipo_compra_sel;
            console.log('Fecha Autorizacion: ', data.fecha_autorizacion)
            
            /* VALIDACION FECHA CADUCIDAD */
            if(this.state.fecha_caducidad){
                let fechaCaducidad = formatearFechaMoment_a_String(this.state.fecha_caducidad);
                let valid = validarFechaMomentEnFormatoString(fechaCaducidad)
                if(valid===false){
                    console.log('ENTRO A CORREGIR')
                    data.Caducidad = null
                    this.setState({fecha_caducidad: null})
                }else{
                    data.Caducidad = formatearFechaMoment_a_String(this.state.fecha_caducidad);
                }
            }
            
            data.plancontable = this.state.planVigente[0].value.toString();
            data.paramIVA = this.state.impuesto_IVA;
            data.PtoFacturacion = this.props.puntoFacturacionSel
            data.Periodo = getItemDatosSesion('periodo');
    
            //DebitoBancario ADDED
            data.debitoBancario = this.state.debitoBancario;
    
            //TOTALES
            data.anticipo = Math.round(parseFloat(this.state.anticipo) * 100) / 100;
            data.retencion = Math.round(parseFloat(this.state.total_retencion) * 100) / 100;
            data.saldo = (this.state.doc_precancelado===true?0:Math.round((data.Importe - data.anticipo - data.retencion) * 100) / 100);
            
            //Detalle de cuentas de gastos
            var grid_CuentasGasto = [];
            if(this.state.grid_cuentas.length > 0){
                this.state.grid_cuentas.forEach((DATA, i)=>{
                    var item = {};
                    item.Localidad = '01';
                    item.Compra = "";
                    item.Secuencia = i + 1;
                    item.Cuenta = DATA.num_cuenta;
                    item.Nombre = DATA.descripcion_Cuenta.toString().trim();
                    item.Valor = parseFloat(DATA.valor);
                    item.IndicadorCC = DATA.centroCosto;
    
                    grid_CuentasGasto.push(item);
                })
                console.log("GRID CUENTAS GASTO: ", grid_CuentasGasto);
    
                data.grid_CuentasGasto = grid_CuentasGasto;
            }
    
            //DETALLE BASES DCOMPRA
            var grid_BASES = [];
            grid_BASES = this.generarGrid_BASES();
            data.array_BASES = grid_BASES;
    
            //DETALLE RETENCIONES
            var grid_retencion = [];
    
            this.state.grid_retenciones.forEach((DATA)=>{
                var item = {};
                item.Retencion = '';
                item.Factura = this.state.num_doc.toString().trim();
                item.Compra = '';
                item.Valor = DATA.base_calculo;
                item.ValorRetenido = DATA.valor;
                item.Porcentaje = DATA.porcentaje;
    
                //MARCADOR DE RETENCION 0%
                if(item.Porcentaje === 0){
                    mensajeRET0 = ' - Existen retenciones por 0%, no se enviara el comprobante electronico'
                }
    
                item.Proveedor = this.state.cod_proveedor.value;
                item.CuentaRetencion1 = DATA.CuentaContable;
                item.Fecha = formatearFechaMoment_a_String(this.state.fecha_proceso);
                item.Codigo = DATA.codigo;
                if(DATA.tipo_imp === "IVA"){
                    item.Observacion = "IVA";
                    item.Rubro = "";
                }else{
                    item.Observacion = "FUENTE";
                    item.Rubro = DATA.rubro_num;
                }
                item.Moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
                item.Dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;
                item.Secuencia = '';
                item.RetencionSRI = '';
                item.Establecimiento = '';
                item.PuntoVenta = '';
                item.Status = 'P';
                item.Tipo = DATA.tipo;
    
                grid_retencion.push(item);
            })
            data.grid_retencion = grid_retencion;
    
            //DETALLE DE ANTICIPOS A ACTUALIZAR
            var grid_Anticipo = [];
            if(seleccionados.length > 0){
                seleccionados.forEach((DATA, i)=>{
                    var item = {};
                    item.ID = DATA.ID;
                    item.PROVEEDOR = this.state.cod_proveedor.value.toString();
                    item.Movimiento = DATA.Movimiento;
                    item.VALOR = DATA.Valor;
                    item.APLICA = DATA.Aplica;
                    item.FECHA = DATA.FECHA;
                    item.Aplicado_Original = DATA.Aplicado_Original;
                    item.Valor_Original = DATA.Valor_Original;
    
                    grid_Anticipo.push(item);
                })
            }
            data.grid_Anticipo = grid_Anticipo;
            
            //Cabecera Libro Diario
            var cab_Contabilidad = {};
            var parametroPLAN = this.state.planVigente;
    
            cab_Contabilidad.Localidad = '01';
            cab_Contabilidad.Movimiento = '';
            cab_Contabilidad.Tipo = 'COM';
            cab_Contabilidad.Fecha = '';
            cab_Contabilidad.Comprobante = '';
            cab_Contabilidad.Descripcion = '';
            cab_Contabilidad.Valor = '';
            cab_Contabilidad.Usuario = data.Usuario;
            cab_Contabilidad.Status = 'P';
            cab_Contabilidad.Moneda = data.Moneda;
            cab_Contabilidad.Dolar = data.Dolar;
            cab_Contabilidad.Secuencia = '';
            cab_Contabilidad.PlanVigente = parametroPLAN[0].value;
    
            data.cab_Contabilidad = cab_Contabilidad;
    
            //DETALLE Libro Diario
            //PILASSSS
            console.log("GRID DE CONTABILIDAD")
            console.log( this.state.grid_contabilidad)
            var grid_Contabilidad = [];
            this.state.grid_contabilidad.forEach((DATA)=>{
                var item = {};
                if(DATA.Cuenta !== undefined){
                    item.Localidad = '01';
                    item.Movimiento = '';
                    item.Secuencia = DATA.Secuencia;
                    item.Cuenta = DATA.Cuenta;
                    item.Concepto = DATA.Concepto;
                    if(DATA.tipo==='I'){//WILLY 20191219 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
                        item.tipo='I'
                        let impor=DATA.Concepto.split(",");
                        item.Importacion=  impor[1];
                        item.Gasto =  impor[2]; 
                    }
                    if(DATA.DebeHaber === 'D'){
                        item.Valor = DATA.ValorD;
                    }else{
                        item.Valor = DATA.ValorH;
                    }
                    item.DebeHaber = DATA.DebeHaber;
                    grid_Contabilidad.push(item);

                }else{
                    if(DATA.Concepto === "Total"){
                        cab_Contabilidad.Valor = DATA.ValorD
                    }
                }
            })
            data.grid_Contabilidad = grid_Contabilidad;
    
            //Proceso si existe importación
            if(this.state.importacion_sel!==null){
                
                data.ImportacionGasto = this.state.importacion_sel.value;
                data.CodGasto = this.state.catGastoImportacion_sel.value;
                data.ValorGasto = valorImportacion
            }
    
            //PROCESOS EXTRA DE MODIFICACION
            if(this.state.operacion === 'M'){
                data.anticiposAplicadosAnulados = this.state.anticiposAplicadosAnulados;
                data.indicadorAnulacioncontabilidad = this.state.reCrearCont;
                data.compra = this.state.movCompra.toString();
                data.ConMovimiento = this.state.ConMovimiento.toString();
            }
            //WILLY 20191219 ->CAMBIO EN COMPRAS MULTIPLES GASTOS
            data.importacionesSeleccionadas=this.state.importacionesSeleccionadas;
            data.esGastoConsolidado=this.state.esGastoConsolidado;
            data.numero_consolidado=this.state.numero_consolidado_seleccionado;
    
            console.log("DATOS ENVIO: ", data)
            
            if(this.state.estadoCompra === 'P'){
                let config_request = {
                    method: this.state.operacion==='G'?'POST':'PATCH',
                    url: this.state.operacion==='G'?'/compras':'/compras/'+this.state.movCompra,
                    data
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then((response)=> {  
                    if(response){
                        console.log('RESPUESTA INS UPD: ', response)
                        this.props.cambiar_VisualizacionLoading(false);
                        
                        //Advertencia para RETENCION 0%
                        if(mensajeRET0){
                            alert(mensajeRET0)
                        }
                        
                        alert(response.data.msg);
                        this.setState({ult_transaccion: response.data.transaction, num_diario: response.data.diario, movCompra: response.data.transaction}, ()=>{
                            this.setState({operacion: 'G'})
                            this.clear('B');
                            this.getCompra();
                        })
                    }else{
                        alert('- Error al cargar data de la compra')
                    }                  
                })
                .catch((error)=>{   
                    this.props.cambiar_VisualizacionLoading(false);             
                    alert(error.response?error.response.data.msg:error.message);  
                });
            }else{
                alert("La compra esta completada o contiene abonos, no se puede modificar")
            }
        }else{
            alert(errors);
        }
    }
    abrirModalGasto(){//WILLY 20191216 ->CAMBIO EN COMPRAS MULTIPLES GASTOS PARA UNA IMPORTACION
        if(this.state.cod_proveedor!=='' && this.state.cod_proveedor!==null && this.state.total_doc>0)
        {      
            this.setState({isVisibleModalGastoImportacion:true})
        }else{
            alert('Debe seleccionar un proveedor para continuar e ingresar un total de Documento')
        }

    }
    eliminarImportacionCallback = (childData) => {//WILLY 20191216 ->CAMBIO EN COMPRAS MULTIPLES GASTOS PARA UNA IMPORTACION
        let total = parseFloat(this.state.total_importacion) - parseFloat(childData.importacion.ValorFOB);  
        this.setState({ data_importaciones: this.immutableDelete(this.state.data_importaciones, parseInt(childData.index,10)), total_importacion:total});
    }
    insertarImportacionCallBack = (childData) => {//WILLY 20191216 ->CAMBIO EN COMPRAS MULTIPLES GASTOS PARA UNA IMPORTACION
        if(this.state.data_importaciones.length===0){
            let total = parseFloat(this.state.total_importacion) + parseFloat(childData.ValorFOB);  
            let porcentaje=(parseFloat(childData.ValorFOB)/parseFloat(total))*100; 
            childData.Porcentaje= porcentaje;
            this.setState({ data_importaciones: this.immutablePush(this.state.data_importaciones, childData), total_importacion:total},()=>{
                let data_importaciones_arr= this.state.data_importaciones;
                for(let i =0; i < data_importaciones_arr.length; i++){
                    porcentaje=(parseFloat(data_importaciones_arr[i].ValorFOB)/parseFloat(total))*100; 
                    data_importaciones_arr[i].Porcentaje= porcentaje.toFixed(2);
                }
                this.setState({data_importaciones:data_importaciones_arr})
            });
        }else{
            alert('Ya se posee una importación ingresada.')
        }
        
    }
    limpiaRetencionContabilidad(){//Willy 20191212->Tarea 54.
        if(this.state.tipoDocumento_sel){
            if(this.state.tipoDocumento_sel.value ==='R'){//Cuando es recibo de caja
                this.actualizarValorNeto(this.state.val_neto_doc , this.state.total_retencion ,"+");
                this.setState({grid_retenciones: [],total_retencion:0},()=>{
                    this.crearAsientoContable()
                });
            }
        }
        
    }
    anularCompra(){
        var mensaje = window.confirm("¿Está seguro en eliminar la transacción #"+this.state.movCompra+"?"); 
        if (mensaje){

            let config_request = {
                method: 'DELETE',
                url: '/compras/'+this.state.movCompra,
            }
            global_axios(config_request)
            .then((response)=> {
                alert(response.data.msg);
                this.clear('B');
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });

        }
    }

    validarTotalArray(array,name){
        var acc = 0;
        array.forEach((DATA)=>{
            acc = acc + parseFloat(DATA[name]);
        })
        return acc;
    }

    validarFechaTrans(fechaEscogida){
        this.setState({fecha_proceso: fechaEscogida});

        var fechaTransaccion = formatearFechaMoment_a_String(this.state.fecha_proceso)

        //VALIDA CUANTOS DIAS PUEDE ESTAR LA FECHA DE FAC ATRAS DE LA FECHA DE PROCESO
        this.validacionFechaTransaccion(this.state.fecha, fechaTransaccion)
    }

    //UPDATE 12/04/18 IMPORTACION SUPPORT
    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    changeImportacion(value){
        this.setState({importacion_sel: value!==null?value:null})

        if(value !== null){
            this.cargarObjetos('/importaciongasto?importacion='+value.value).then((resultImp)=>{
                console.log("RESULTADO: ", resultImp);

                var catalogoReformado = [];
                resultImp.forEach((IMP)=>{
                    var item = {};

                    item.value = IMP.Codigo;
                    item.label = IMP.Descripcion+' ('+IMP.Codigo+')';
                    item.Valor = IMP.Valor;
                    catalogoReformado.push(item);
                })

                this.setState({catGastoImportacion: catalogoReformado})
            })
            .catch((error)=>{
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            this.setState({catGastoImportacion: [], catGastoImportacion_sel: null})
        }
        
    }

    impCompra(){
        visualizarReporteEnPdf('&rpt=28&param1='+this.state.movCompra)
    }
    impRetencion(){
        visualizarReporteEnPdf('&rpt=109&param1='+this.state.movCompra)
    }

    validarTipoDoc(){
        let desactivado = true;
        if(this.state.tipoDocumento_sel){
            if(this.state.tipoDocumento_sel.NoProcesarRet === null){
                desactivado = false;
            }
        }
        return desactivado;
    }

    render(){
        const invisible = {display: 'none'};
        const visible = {display: 'block'};
        return(
            <ContenedorForm porc_ancho={85}>
            <HeaderForm>
                <TituloForm>Compras Generales</TituloForm>
                <LabelCabecera>Neto: {this.state.val_neto_doc===undefined?'':this.state.val_neto_doc}</LabelCabecera>
                <LabelCabecera>Total RET: {this.state.total_retencion===undefined?'':this.state.total_retencion}</LabelCabecera>   
                <LabelCabecera>Base IVA: {this.state.base_IVA_grabado===undefined?'':this.state.base_IVA_grabado}</LabelCabecera>        
                <LabelCabecera>BASE RET: {this.state.base_ret_renta===undefined?'':this.state.base_ret_renta}</LabelCabecera>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                <LabelCabecera>N°. diario.: {this.state.num_diario}</LabelCabecera> 
                
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            <ContainerCol className='col-md-1'>
                                <LabelForm>Compra: </LabelForm>
                            </ContainerCol>                           
                            <ContainerCol className='col-md-2'>                                
                                {/* <div className='input-group'>
                                    <InputText name='movimiento' value={this.state.movCompra} type="number" className='form-control input-sm' onChange={this.changeMovimientoCompra} onBlur={this.setOperacion}/>
                                    <span className='input-group-addon addon-busq-especif'><button type="button" className='btn btn-default medida-button-busq-especif' onClick={this.getCompra}><i className="fa fa-check-circle-o"></i> Seleccionar</button></span>
                                </div> */}
                                <InputSearch tipoInput='text' nombre='movCompra' placeholder='Compra' valor={this.state.movCompra} func_CambiarValor={this.changeMovimientoCompra}
                                func_BuscarValor={this.getCompra} func_OnFocus={()=>{this.clear('B')}} func_Onblur={this.setOperacion} />
                            </ContainerCol>
                            <ContainerCol className='col-md-1 col-md-push-6'> 
                                <LabelForm>Fecha. Trans.:</LabelForm>
                            </ContainerCol>
                            <ContainerCol className='col-md-2 col-md-push-6'> 
                                <PickerFecha fechaSeleccionada={this.state.fecha_proceso} disabled={!(this.props.permiteCambioFProceso==='S')} func_onChange={(fechaEscogida)=>{this.validarFechaTrans(fechaEscogida)}}/>
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha factura:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fecha} func_onChange={(fechaEscogida)=>{this.changeFecha(fechaEscogida)}}/>
                        </ContainerCol>

                        <ContainerCol className='col-md-4'>
                            <LabelForm>Proveedor:</LabelForm>
                            <ReactSelectAsync value={this.state.cod_proveedor} disabled={this.state.operacion === 'G'?false:true} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.changeProveedor(value)}} func_onBlur={(value)=>{this.setProveedor(value)}} />
                        </ContainerCol>

                        <ContainerCol className='col-md-1'>
                            <LabelForm>Débito Bancario:</LabelForm><br/>
                            <LabelForm><input type='checkbox' name='debitoBancario' checked={this.state.debitoBancario==='S'?true:false} onChange={this.changeValueGeneral}/></LabelForm> 
                        </ContainerCol>

                        <ContainerCol className='col-md-3'>
                            <LabelForm>N° autorización:</LabelForm>
                            <InputText  name='num_autorizacion' value={this.state.num_autorizacion}  disabled={this.state.operacion === 'G'?false:true} type="number" className='form-control input-sm'  onChange={this.changeValueGeneral}/>
                        </ContainerCol>

                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha caducidad:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fecha_caducidad}  disabled={this.state.operacion === 'G'?false:true} func_onChange={(fechaEscogida)=>{this.setState({fecha_caducidad: fechaEscogida})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Tipo documento:</LabelForm>
                            <ReactSelect options={ this.state.tipoDocumento } value={this.state.tipoDocumento_sel} disabled={this.state.operacion === 'G'?false:true} func_onChange={(value)=>{value!==null?this.setState({tipoDocumento_sel: value}):this.setState({tipoDocumento_sel: null})}} func_onBlur={(value)=>{this.limpiaRetencionContabilidad()}}/>
                        </ContainerCol>
                        
                        <ContainerCol className='col-md-2'>
                            <LabelForm>N° documento:</LabelForm>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"></span>
                                </div>
                                <InputText2 className='input-sm' type="text" name='num_doc_serie' disabled={this.state.cod_proveedor===null || this.state.operacion === 'M'?true:false} value={this.state.num_doc_serie} onChange={this.changeNumSerie} onBlur={this.validNumSerie}/>
                                <InputText2 className='input-sm' type="text" name='num_doc' disabled={this.state.cod_proveedor===null || this.state.operacion === 'M'?true:false} value={this.state.num_doc}  onChange={this.changeNumFactura} onBlur={this.validadFacturaProveedor}/>
                            </div>
                        </ContainerCol>

                        <ContainerCol className='col-sm-5'>
                            <LabelForm>Cretido Tributario:</LabelForm>
                            <ReactSelect options={ this.state.tipo_compra_opt } value={this.state.tipo_compra_sel} func_onChange={(value)=>{this.setState({tipo_compra_sel: value?value.value:null})}}/>
                        </ContainerCol>

                        <ContainerCol className='col-md-1'>
                            <LabelForm>Días pg.:</LabelForm>
                            <InputText name='dias_pago' value={this.state.dias_pago} type="number" className='form-control input-sm' placeholder='$$' onChange={this.changeValueGeneral} onBlur={this.setFechaPago}/>
                        </ContainerCol>

                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha vencimiento:</LabelForm>
                            <PickerFecha disabled={true} fechaSeleccionada={this.state.fecha_vencimiento} func_onChange={(fechaEscogida)=>{this.setState({fecha_vencimiento: fechaEscogida})}}/>
                        </ContainerCol>

                        {/* <ContainerCol className='col-md-1 form-group'>
                            <LabelForm>¿Cancelado?</LabelForm>
                            <Checkbox name='doc_precancelado' checked={this.state.doc_precancelado} type="checkbox" className='form-control input-sm' onChange={this.changeValueGeneral}/>
                        </ContainerCol> */}
                    </Row>
                    <Row>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Total documento:</LabelForm>
                            <InputText name='total_doc' value={this.state.total_doc} disabled={this.state.cod_proveedor===null || this.state.operacion==="M"?true:false} type="number" className='form-control input-sm' placeholder='$$' min="0" onChange={this.changeValueGeneral} onBlur={this.changeTotalDoc}/>
                        </ContainerCol>

                        <ContainerCol className='col-md-2'>
                            <LabelForm>Base IVA 0%:</LabelForm>
                            <InputText name='base_0_doc' value={this.state.base_0_doc} disabled={this.state.cod_proveedor===null || this.state.operacion==="M"?true:false} type="number" className='form-control input-sm' placeholder='$$' min="0" onChange={this.changeValueGeneral} onBlur={this.changeBaseIVA_0}/>
                        </ContainerCol>

                        <ContainerCol className='col-md-2'>
                            <LabelForm>Base No Objeto IVA:</LabelForm>
                            <InputText name='base_no_obj' value={this.state.base_no_obj} disabled={this.state.cod_proveedor===null || this.state.operacion==="M"?true:false} type="number" className='form-control input-sm' placeholder='$$' min="0" onChange={this.changeValueGeneral} onBlur={this.changeBaseNoObjIVA}/>
                        </ContainerCol>

                        <ContainerCol className='col-md-3'>
                            <LabelForm>Cuenta contable:</LabelForm>
                            <ReactSelectAsync value={this.state.cuenta_add} disabled={this.state.cod_proveedor===null?true:false} func_loadOptions={this.getOptions_CtaContable} func_onChange={(value)=>{this.changeCuentaAdd(value)}} /*func_onBlur={(value)=>{this.setCuenta(value)}}*//>
                        </ContainerCol>

                        <ContainerCol className='col-md-2'>
                            <LabelForm>Valor:</LabelForm>
                            <InputText name='valor_add' value={this.state.valor_add} disabled={this.state.cod_proveedor===null?true:false} type="number" className='form-control input-sm' onChange={this.changeValueGeneral}/>
                        </ContainerCol>

                        <ContainerCol className='col-md-1'>
                            <ContenedorBotonAdd>
                                <button type="button" className='btn btn-success btn-sm' disabled={this.state.cod_proveedor===null?true:false} onClick={this.addCuenta.bind(this)}><i className="fa fa-plus"></i></button>
                            </ContenedorBotonAdd>
                        </ContainerCol>
                    </Row>
                    <Row>
                        {/* <ContainerCol className='col-sm-3'>
                            <LabelForm>Importación:</LabelForm>
                            <ReactSelectAsync value={this.state.importacion_sel}  func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.changeImportacion(value)}}/>
                        </ContainerCol> 
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Cod. Gasto:</LabelForm>
                            <ReactSelect options={ this.state.catGastoImportacion } disabled={this.state.importacion_sel===null?true:false} value={this.state.catGastoImportacion_sel} func_onChange={(value)=>{this.setState({catGastoImportacion_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Valor:</LabelForm><br/>
                            <LabelForm>{this.state.catGastoImportacion_sel===null?'0.00':this.state.catGastoImportacion_sel.Valor}</LabelForm>
                        </ContainerCol>  */}
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo Proveedor.:</LabelForm>
                            <InputText name='tipo_proveedor' value={this.state.tipo_proveedor.descripcion} disabled={true} type="text" className='form-control input-sm'/>
                        </ContainerCol>

                        {/* <ContainerCol className='col-md-2'>
                            <LabelForm>Anticipo a aplicar:</LabelForm>
                            <InputText name='anticipo' value={this.state.anticipo} type="number" disabled={true} className='form-control input-sm' placeholder='$$' onChange={this.changeValueGeneral}/>
                        </ContainerCol> */}
                    </Row>
                    <Row>                        
                        <ContainerCol className='col-md-5'>                            
                            <LabelForm>Anticipos pendientes:</LabelForm>
                            <AgGridRender altura='100px' data={this.state.grid_anticipos} columnas={this.state.columnDefs_anticipos} gridOptions={this.gridOptionsAnticipos} onGridReady={this.onGridReadyAT}/>                                                           
                            <div className='flex-container' >
                                <div className='flex-item'>
                                    <LabelForm>Total anticipos aplicados:</LabelForm>
                                </div>
                                <div className='flex-item-ajust'>
                                    <InputText name='selected_anticipos' value={this.state.selected_anticipos} disabled={true} type="number" className='form-control input-sm' onChange={this.changeValueGeneral}/>
                                </div>                                
                                <div  className='flex-item-ajust' style={(this.state.operacion==='M')&&(this.state.grid_anticiposAplicados.length > 0)?visible:invisible}>
                                    <BotonLink type="button"  disabled={(this.state.operacion==='M')&&(this.state.grid_anticiposAplicados.length > 0)?false:true} onClick={this.toggleModalAnticiposAplicados.bind(this)}>Ver ant. aplicados</BotonLink>
                                </div>
                            </div>
                        </ContainerCol>

                        <ContainerCol className='col-md-6  col-md-offset-1'>
                            <LabelForm>Cuentas:</LabelForm>
                            <AgGridRender  altura='100px' data={this.state.grid_cuentas} columnas={this.state.columnDefs_cuentas} gridOptions={this.gridOptionsCuentas} onGridReady={this.onGridReadyCu}/>   
                            <div className='flex-container' >
                                <div className='flex-item'>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"></span>
                                        </div>
                                        <InputText2 className='input-sm' type="text" name='cuenta_IVA' value={this.state.cuenta_IVA} readOnly={true} onChange={this.changeValueGeneral}/>
                                        <InputText2 className='input-sm' type="text" name='cuenta_IVA_Des' value={this.state.cuenta_IVA_Des} readOnly={true} onChange={this.changeValueGeneral}/>
                                    </div>
                                </div>
                                <div className='flex-item-ajust'>
                                    <InputText name='valor_IVA' value={this.state.valor_IVA} disabled={true} type="number" className='form-control input-sm' placeholder='$$' onChange={this.changeValueGeneral}/>
                                </div>
                            </div>                                                        
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={5}>
                        <div className='col-md-5'>
                            <InputText name='concepto' value={this.state.concepto} type="text" className='form-control input-sm' placeholder='Concepto...' onChange={this.changeValueGeneral} mayusculas='true'/>
                        </div>             
                        <div className='col-md-7'>
                            <div className="btn-group pull-right">
                            <button type="submit" className='btn btn-primary btn-sm' disabled={this.state.errorFechas===1 || this.state.errorCuentas===1?true:false} onClick={this.guardarCompra}>
                                <i className="fa fa-floppy-o fa-lg"></i> Guardar
                            </button>
                            <button type="button" className='btn btn-danger btn-sm' disabled={this.state.operacion==='M'?false:true} onClick={this.anularCompra}>
                                <i className="fa fa-ban fa-lg"></i> Anular
                            </button>
                            <button type="button" className='btn btn-sm' onClick={()=>{this.clear('A')}}>
                                <i className="fa fa-trash-o fa-lg"></i> Limpiar
                            </button>                            
                            <button type="button" className='btn btn-default btn-sm' disabled={this.validarTipoDoc()} onClick={this.toggleModalRetencion}>
                                <i className="fa fa-book fa-lg"></i> Retención
                            </button>
                            <button type="button" className='btn btn-default btn-sm' disabled={this.state.checkRetencion === 1 || this.validarTipoDoc()===true?false:true} onClick={this.toggleModalContabilidad}>
                                <i className="fa fa-bar-chart fa-lg"></i> Contabilidad
                            </button>                            
                            <button type='button' className='btn btn-info btn-sm' disabled={this.state.movCompra===''?true:false} onClick={this.impCompra}>
                                <i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir
                            </button>
                            <button type='button' className='btn btn-default btn-sm' disabled={this.state.movCompra===''?true:false} onClick={this.impRetencion}>
                                <i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir Retención
                            </button>
                            <button type='button' className='btn btn-default btn-sm'  onClick={this.abrirModalGasto}>
                                <i className="fa fa-credit-card  fa-lg" aria-hidden="true"/>Gasto Importación
                            </button>
                            </div>
                        </div>                  
                    </Row>
                </CuerpoForm>

                {/*MODAL RETENCION*/}
                <ModalResponsive open={this.state.isOpenRetencion} onClose={this.closeRetencion}>
                    <HeaderForm>
                        <TituloForm>Retenciones</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModal>
                            <Row>
                                <ContainerCol className='col-md-1 '>
                                    <LabelForm>Serie: </LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-4  col-md-offset-7 col-md-pull-6'>
                                    <PuntoFacturacion disabled={true}/>
                                </ContainerCol>
                            </Row> 
                            <Row>
                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Tipo retención:</LabelForm>
                                    <ReactSelect options={ this.state.tipoRetencion } disabled={this.state.operacion==='M'?true:false} value={this.state.tipoRetencion_sel} func_onChange={(value)=>{this.setState({tipoRetencion_sel: value})}} />
                                </ContainerCol>
                                <ContainerCol className='col-md-3'>
                                    <LabelForm>Impuesto:</LabelForm>
                                    <ReactSelect options={ this.state.opc_impuestos } disabled={this.state.operacion==='M'?true:false} value={this.state.opc_impuestos_sel} func_onChange={(value)=>{this.changeImpuesto(value)}} />
                                </ContainerCol>
                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Porcentaje:</LabelForm>
                                    <InputText name='porcentaje_imp' value={this.state.porcentaje_imp} disabled={true} type="number" className='form-control input-sm' placeholder='%' onChange={this.changeValueGeneral}/>
                                </ContainerCol>
                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Base imponible:</LabelForm>
                                    <InputText name='base_imponible' value={this.state.base_imponible} disabled={this.state.operacion==='M'?true:false} type="number" className='form-control input-sm' placeholder='0.00' onChange={this.changeValueGeneral} onBlur={this.changeBase_imponible_RET}/>
                                </ContainerCol>
                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Valor impuesto:</LabelForm>
                                    <InputText name='valor_impuesto' value={this.state.valor_impuesto} disabled={true} type="number" className='form-control input-sm' placeholder='0.00' onChange={this.changeValueGeneral}/>
                                </ContainerCol>
                                <ContainerCol className='col-md-1'>
                                    <ContenedorBotonAdd>
                                        <button type="button" className='btn btn-success btn-sm' disabled={this.state.operacion==='M'?true:false} onClick={this.addImpuesto.bind(this)}><i className="fa fa-plus"></i></button>
                                    </ContenedorBotonAdd>
                                </ContainerCol>
                            </Row>
                            <Row>{/*Controles Extra para Opcion Bienes*/}
                                <div style={(this.state.fila_impuesto.Tipo==="RTF")?visible:invisible}>
                                    <ContainerCol className='col-md-2'>
                                        <LabelForm>Rubro:</LabelForm>
                                    </ContainerCol>

                                    <ContainerCol className='col-md-10 '>
                                        <ReactSelectAsync value={this.state.rubro} func_loadOptions={this.getOptions_RubroImp} func_onChange={(value)=>{this.setState({rubro: value})}}/>
                                    </ContainerCol>
                                </div>
                            </Row>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <AgGridRender altura='140px' data={this.state.grid_retenciones} columnas={this.state.columnDefs_retenciones} gridOptions={this.gridOptionsRetenciones} onGridReady={this.onGridReadyRET}/>                                                           
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Total doc.:</LabelForm>
                                    <InputText name='total_doc' value={this.state.total_doc} disabled={true} type="number" className='form-control input-sm' placeholder='$$' onChange={this.changeValueGeneral}/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Valor neto doc.:</LabelForm>
                                    <InputText name='val_neto_doc' value={this.state.val_neto_doc} disabled={true} type="number" className='form-control input-sm' placeholder='$$' onChange={this.changeValueGeneral}/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>B. graba IVA:</LabelForm>
                                    <InputText name='base_IVA_grabado' value={this.state.base_IVA_grabado} disabled={true} type="number" className='form-control input-sm' placeholder='$$' onChange={this.changeValueGeneral}/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>B. ret. renta:</LabelForm>
                                    <InputText name='base_ret_renta' value={this.state.base_ret_renta} disabled={true} type="number" className='form-control input-sm' placeholder='$$' onChange={this.changeValueGeneral}/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>IVA:</LabelForm>
                                    <InputText name='valor_IVA' value={this.state.valor_IVA} disabled={true} type="number" className='form-control input-sm' placeholder='$$' onChange={this.changeValueGeneral}/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Total retención:</LabelForm>
                                    <InputText name='total_retencion' value={this.state.total_retencion} disabled={true} type="number" className='form-control input-sm' placeholder='$$' onChange={this.changeValueGeneral}/>
                                </ContainerCol>
                            </Row>                                       
                        </ContenedorModal>
                    </CuerpoForm>
                </ModalResponsive>

                {/*MODAL Contabilidad*/}
                <ModalResponsive  open={this.state.isOpenContabilidad} onClose={()=>{this.setState({isOpenContabilidad:false})}}>
                    <HeaderForm>
                        <TituloForm>Asiento generado</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModalConb>
                            <Row>
                                <ContainerCol className='col-md-12' style={(this.state.operacion==='M')?visible:invisible}>
                                    <LabelForm>Número del libro: {this.state.ConMovimiento}</LabelForm>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelForm>Asiento contable:</LabelForm>
                                    <AgGridRender  altura='240px' data={this.state.grid_contabilidad} columnas={this.state.cols_contabilidad} gridOptions={this.gridOptionsContabilidad} onGridReady={this.onGridReadyCO}/>   
                                </ContainerCol>
                            </Row>
                        </ContenedorModalConb>
                    </CuerpoForm>
                </ModalResponsive>

                {/*MODAL CENTRO DE COSTO*/}
                <ModalResponsive open={this.state.isOpenCentroCosto} onClose={()=>{this.setState({isOpenCentroCosto:false})}}>
                    <HeaderForm>
                        <TituloForm>Centro de costo</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModal>
                            <Row>
                                <ContainerCol className='col-md-3'>
                                    <LabelForm>Tipo costo:</LabelForm>
                                    <ReactSelect options={ this.state.tipoCosto } value={this.state.tipoCosto_sel} func_onChange={(value)=>{this.setState({tipoCosto_sel: value})}} />
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Ubicación:</LabelForm>
                                    <ReactSelect options={ this.state.ubicacion } value={this.state.ubicacion_sel} func_onChange={(value)=>{this.setState({ubicacion_sel: value})}} />
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Centro costo:</LabelForm>
                                    <InputText name='centro_costo' value={this.state.centro_costo} type="text" className='form-control input-sm' placeholder='$$' min="0" onChange={this.changeValueGeneral}/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Porcentaje:</LabelForm>
                                    <InputText name='cc_procentaje' value={this.state.cc_procentaje} type="number" className='form-control input-sm' placeholder='$$' min="0" onChange={this.changeValueGeneral}/>
                                </ContainerCol>

                                <ContainerCol className='col-md-2'>
                                    <LabelForm>Valor:</LabelForm>
                                    <InputText name='cc_valor' value={this.state.cc_valor} type="number" className='form-control input-sm' placeholder='$$' min="0" onChange={this.changeValueGeneral}/>
                                </ContainerCol>

                                <ContainerCol className='col-md-1'>
                                    <ContenedorBotonAdd>
                                        <button type="button" className='btn btn-success btn-sm' onClick={this.addCentroCosto.bind(this)}><i className="fa fa-plus"></i></button>
                                    </ContenedorBotonAdd>
                                </ContainerCol>
                            </Row>                                
                            <Row>
                                <ContainerCol className='col-md-11 col-md-offset-1 col-md-pull-1'>
                                        <LabelForm>Centro de costos asignados:</LabelForm>
                                        <AgGridRender altura='140px' data={this.state.grid_centroCosto} columnas={this.state.columnDefs_centroCostos} gridOptions={this.gridOptionsCentroCosto} onGridReady={this.onGridReadyCC}/>
                                </ContainerCol>                                
                            </Row>
                        </ContenedorModal>
                    </CuerpoForm>
                </ModalResponsive>

                {/*MODAL ANTICIPOS APLICADOS (MODIFICACION)*/}
                <ModalResponsive open={this.state.isOpenAnticipoAplicados} onClose={()=>{this.setState({isOpenAnticipoAplicados:false})}}>
                    <HeaderForm>
                        <TituloForm>Anticipos Aplicados</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModalCont>
                            <ContainerCol className='col-md-10 col-md-offset-2 col-md-pull-2'>
                                <AgGridRender altura='100px' data={this.state.grid_anticiposAplicados} columnas={this.state.columnDefs_anticiposAP} gridOptions={this.gridOptionsAnticiposAP} onGridReady={this.onGridReadyAP}/>       
                            </ContainerCol>
                        </ContenedorModalCont>
                    </CuerpoForm>
                </ModalResponsive>
                {/*MODAL DE GASTO IMPORTACION*/}
                 <GastoImportacionModal 
                      parentCallback = {this.callbackFunction}
                      actulizaGridGastoCallBack= {this.actulizaGridGastoCallBack}
                      actulizaNumeroConsolidadoCallBack= {this.actulizaNumeroConsolidadoCallBack}
                      actualizaTotalGastoDistribuidoCallBack= {this.actualizaTotalGastoDistribuidoCallBack}
                      actualizaTotalGeneralCallBack={this.actualizaTotalGeneralCallBack}
                      actualizacatRubroGastoImportacion_selCallBack={this.actualizacatRubroGastoImportacion_selCallBack}
                      cargarImportacionesCallBack = {this.cargarImportacionesCallBack}
                      insertarImportacionCallBack={this.insertarImportacionCallBack}
                      limpiarModalImportacionCallBack={this.limpiarModalImportacionCallBack}
                      eliminarImportacionCallback={this.eliminarImportacionCallback}
                      total_importacion= {this.state.total_importacion}
                      total_gasto_general={this.state.total_gasto_general}
                      total_gasto_distribuido= {this.state.total_gasto_distribuido}
                      close={this.closeModal}
                      visible={this.state.isVisibleModalGastoImportacion}
                      data_importaciones={this.state.data_importaciones}
                      title="Gasto Importación"
                      numero_consolidado={this.state.numero_consolidado}
                      gastos_importacion={this.state.gastos_importacion}
                      operacion={this.state.operacion}
                      catRubroGastoImportacion_sel={this.state.catRubroGastoImportacion_sel}
                      onClose={()=>{this.setState({isVisibleModalGastoImportacion: false})}}
                   />
                     
              
            </ContenedorForm>
        )
    }

}


const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias}
  });
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm
                        , cambiar_VisualizacionLoading }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormComp02);